
/*!********************************!*\
  !*** magicVKeypad.js ************!
  !*** v1.2.3.5        ************!
  !********************************!
  !*** 20250422 deployed **********!
  \********************************/
/*
 * MagicLine4Web VirtualKeyboard
 *
 * (C) 2020. Dreamsecurity,Inc. All rights reserved.

゜・。゜ ・・゜ ・ 。。 ゜・。 。 。 ゜。・゜ ❅。 ❅・。・。 ゜・ 。゜ ・ 。。゜・。 ❅゜
゜ ・ 。゜・ ❆゜ ・。❅゜❅ ゜・ 。 ❅゜ ゜ ・。゜ ・・❆ ゜・ 。 ゜❅゜ ゜゜・。 。 ゜・。
。 。゜ ・ 。 ❆・❅ ゜゜・。 ゜・ ❆゜・ 。 ❅゜ ゜・。゜ ・・゜ ・ 。。 ゜・。 。 。 ゜。・
゜ ❅。 ❅・。・。 ゜・ 。゜ ・ 。。゜・。 ❅゜ ゜ ・ 。゜・ ❆゜ ・。❅゜❅ ゜・ 。 ❅゜ ゜
・。゜ ・・❆ ゜・ 。 ゜❅゜ ゜゜ 𝕄𝕒𝕘𝕚𝕔𝕍𝕂𝕖𝕪𝕡𝕒𝕕 。 。゜ ・ 。 ❆・❅ ゜゜・。 ゜・ ❆゜・ 。
❅゜ ゜・。゜ ・・゜ ・ 。。 ゜・。 。 。 ゜。・゜ ❅。 ❅・。・。 ゜・ 。゜ ・ 。。゜・。
❅゜ ゜ ・ 。゜・ ❆゜ ・。❅゜❅ ゜・ 。 ❅゜ ゜ ・。゜ ・・❆ ゜・ 。 ゜❅゜ ゜゜・。 。 ゜
・。 。 。゜ ・ 。 ❆・❅ ゜゜・。 ゜・ ❆゜・ 。 ❅゜ ゜・゜゜❅゜ ・。 ❅゜゜ ・ 。゜・ ゜
・。゜ ・・゜ ・ 。。 ゜・。 。 。 ゜。・゜ ❅。 ❅・。・。 ゜・ 。゜ ・ 。。゜・。 ❅゜ ゜
・ 。゜・ ❆゜ ・。❅゜❅ ゜・ 。 ❅゜ ゜ ・。゜ ・・❆ ゜・ 。 ゜❅゜ ゜゜・。 。 ゜・。 。
 *
 */
/**************************************************
 *
 */
//'use strict'
var MLVKeyConfig = {
	magicjsLicense    : 'P5hdK49xOUilp6sOmNz4l3E41NZ92M2b7K6CBUeydeIZXVXrNh9HUAXTI2OAXDTCEHEwzuR7Io0++rTey/5vfShmxWtCRmYC/NH01B74uj+I3QojnNFgG1H49lJlhZhK36M2D8p+mAneU0DKMO/pQ2IbTh54WOXT4FQoeCMzvNSGeIpt85hcakzXO3otI4b+zcfqvWVGFLbz+qRDUbapwiWgNi+C8R4wC3vXTNjJiFGTupVMu1Bi5Mgs1nGbfrdMTJMPS0KaYkRKvOpqNJshV5qfwIcaeVtasoprDJdBBg4lGMUnEw/qBPmdr6YQXOxi8wDnM3ptRQa3q8N0BnNFlg=='
	, servlet 			: 'response.jsp'
	, sessionTimeout	: 60*5
	, isMultiCursor		: false
	, isKeyPress		: true
	, mobileKeyPress	: "#1E90FF"
	, accessibility 	: true
}


var MLVKeyErrCode = {AXERR_OK:	0
	, AXERR_LICENSEEXPIRED			: {code: 30000,	message: '라이센스 정보(만료일 또는 도메인)를 확인하시기 바랍니다.'}
	, AXERR_NOTSETPROPERTY 			: {code: 30001,	message: '초기화 설정에 실패하였습니다.'}
	, AXERR_INVALIDINPUT 			: {code: 30002,	message: '입력받은 데이터가 올바르지 않습니다.'}
	, AXERR_FAILINITALIZE 			: {code: 30003,	message: '초기화에 실패했습니다.'}
	// 암호화 관련
	, AXERR_NOTSERVERCERT			: {code: 30050,	message: '웹서버로부터 다운받은 서버인증서가 없습니다.'}
	, AXERR_MAKESESSIONID_FAIL		: {code: 30052,	message: '세션정보 생성에 실패하였습니다.'}
	, AXERR_NOTEXISTSESSIONINFO		: {code: 30053,	message: '세션정보가 존재하지 않습니다.로그인후에 다시 이용하십시오.'}
	, AXERR_ENCRYPT_FAIL			: {code: 30055,	message: '메세지 암호화에 실패하였습니다.'}
	, AXERR_DECRYPT_FAIL			: {code: 30056,	message: '메세지 복호화에 실패하였습니다.'}
	, AXERR_HASH_FAIL				: {code: 30057,	message: '데이터의 해시 생성에 실패하였습니다.'} // 인증서 설정값 확인해주세요
	, AXERR_INVALIDHASH_FAIL		: {code: 30058,	message: '데이터 무결성 오류(해쉬값이 일치하지 않습니다)'}
	, AXERR_MAKEKDF_FAIL			: {code: 30059,	message: '서버와 암/복호화시 사용될 통신키 생성에 실패하였습니다.'}
	, AXERR_MAKEMSG_FAIL			: {code: 30060,	message: '서버로 전송할 암호화 메세지 생성에 실패하였습니다.'}
	, AXERR_PARSEMSG_FAIL			: {code: 30061,	message: '서버로부터 전송받은 메세지가 올바르지 않습니다.'}
	, AXERR_INVALID_DATA			: {code: 30062,	message: '입력받은 데이터가 올바르지 않습니다.'}
	// 기타오류
	, AXERR_API_SCRIPT				: {code: 40000,	message: '스크립트에 오류가 발생하였습니다.'}
}

if (typeof(Object.assign) != "function") {
	Object.assign = function(target, varArgs) { // .length of function is 2
		'use strict';
		if (target == null) { // TypeError if undefined or null
			throw new TypeError("Cannot convert undefined or null to object");
		}
		var to = Object(target);
		for (var index = 1; index < arguments.length; index++) {
			var nextSource = arguments[index];
			if (nextSource != null) { // Skip over if undefined or null
				for (var nextKey in nextSource) {
					// Avoid bugs when hasOwnProperty is shadowed
					if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
						to[nextKey] = nextSource[nextKey];
					}
				}
			}
		}
		return to;
	};
}

if (typeof(String.format) == "undefined") {
	String.format = function() {
		var expression = arguments[0];
		for (var i=1; i < arguments.length; i++) {
			var prttern = "{" + (i - 1) + "}"
			expression = expression.replace(prttern, arguments[i]);
		}
		return expression;
	}
}

if (typeof(XMLHttpRequest) == "undefined") {
	XMLHttpRequest = function() {
		try {
			return new ActiveXObject("Msxml2.XMLHTTP.6.0");
		} catch(e) { };
		try {
			return new ActiveXObject("Msxml2.XMLHTTP.3.0");
		} catch(e) { };
		try {
			return new ActiveXObject("Msxml2.XMLHTTP");
		} catch(e) { };
		try {
			return new ActiveXObject("Microsoft.XMLHTTP");
		}  catch(e) { };
		throw new Error("This browser does not support XMLHttpRequest or XMLHTTP.");
	};
}

// [참고] E2E 원본 소스
var MLJSCrypto = (function() {
	var mLicenseFlag = true;
	Define = {
		PKI_OPT					: 0
		, PKI_CERT_SIGN_OPT_NONE			: 'OPT_NONE'				// 0
		, PKI_CERT_SIGN_OPT_USE_CONTNET_INFO: 'OPT_USE_CONTNET_INFO'	// 1
		, PKI_CERT_SIGN_OPT_NO_CONTENT		: 'OPT_NO_CONTENT'			// 2
		, PKI_CERT_SIGN_OPT_SIGNKOREA_FORMAT: 'OPT_SIGNKOREA_FORMAT'	// 4
		, PKI_CERT_SIGN_OPT_HASHED_CONTENT	: 'OPT_HASHED_CONTENT'		// 18
		, PKI_RSA_1_5						: 'rsa15'
		, PKI_RSA_2_0						: 'rsa20'
		, PKI_RSA_1_5_STRING				: 'RSASSA-PKCS1-V1_5'		// internal function
		, PKI_RSA_2_0_SIGN					: 'RSA-PSS'					// internal function
		, PKI_RSA_2_0_ENVELOP				: 'RSA-OAEP'				// internal function
		/* 해쉬 알고리즘 */
		, HASH_ALG_CERT						: 'CertHash'				// 인증서해쉬
		, HASH_ALG_SHA1						: 'SHA1'					// 0x00000001	/* SAH1 */
		, HASH_ALG_SHA256					: 'SHA256'					// 0x00000004	/* SHA256 */
		, HASH_ALG_SHA512					: 'SHA512'					// 0x00000005	/* SHA512 */
		/* 대칭키 알고리즘 */
		, SYM_ALG_3DES_CBC					: 'des-EDE3'				// 0x20	/* 3DES CBC */
		, SYM_ALG_SEED_CBC					: 'seed'					// 0x30	/* SEED CBC */
		, SYM_ALG_ARIA_CBC					: 'aria128'					// 0x40	/* ARIA 128bit key CBC */
		, SYM_ALG_ARIA_192BIT_CBC			: 'aria192'					// 0x41	/* ARIA 192bit key CBC */
		, SYM_ALG_ARIA_256BIT_CBC			: 'aria256'					// 0x42	/* ARIA 256bit key CBC */
		, SYM_ALG_AES_CBC					: 'aes128'					// 0x50	/* AES 128bit key CBC */
		, SYM_ALG_AES_192BIT_CBC			: 'aes192'					// 0x51	/* AES 192bit key CBC */
		, SYM_ALG_AES_256BIT_CBC			: 'aes256'					// 0x52	/* AES 256bit key CBC */
		, ENCRYPTED_DATA		 			: 0
		, ENCRYPTED_SIGNED_DATA				: 1
		, SIGNED_DATA			 			: 20
		, SIGNED_CONTENT 					: 30
		, ENVELOP_DATA 		 				: 21
		, WAP_ENVELOP_DATA 					: 31
		, ENVELOP_SIGN_DATA 				: 22
		, ENVELOP_WAP_SIGN_DATA 			: 32
		, LOGIN_ENVELOP_SIGN_DATA			: 23
		, LOGIN_ENVELOP_WAP_SIGN_DATA		: 33
	}
	GetStringToArrayBuffer = function(value) {
		var arrayBuffer = [];

		for (var i=0; i<value.length; i++) {
			arrayBuffer[i] = value.charCodeAt(i);
		}

		return arrayBuffer;
	}

	GetArrayBufferToString = function(value) {
		var result;

		result = String.fromCharCode.apply(null, value);

		return result;
	}

	GetIntegerToArrayBuffer = function(value, size) {
		var arrayBuffer = [];
		var idx = size;
		var result;

		do {
			arrayBuffer[--idx] = value & (255);
			value = value >> 8;
		} while (idx);

		return arrayBuffer;
	}

	GetArrayBufferToInteger = function(value) {
		var result = 0;

		for (var i=0; i<value.length; ++i) {
			result += value[i];
			if (i<value.length-1) {
				result = result << 8;
			}
		}

		return result;
	}

	MakeKeyBlock = function(sAlgo, sMasterSecret, sClientMsg, callback) {
		var oResult = 0;
		var KeyBlock = new Array(4);
		var MasterSecret;
		var ClientMsg;
		var TempData = [];
		var HashData;
		var TotalKeyBlock = [];

		try {
			if (sAlgo == null || typeof(sAlgo) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(sAlgo)"};
			}
			if (sMasterSecret == null || typeof(sMasterSecret) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(sMasterSecret)"};
			}
			if (sClientMsg == null || typeof(sClientMsg) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(sClientMsg)"};
			}

			KeyBlock[0] = GetStringToArrayBuffer("A");
			KeyBlock[1] = GetStringToArrayBuffer("BB");
			KeyBlock[2] = GetStringToArrayBuffer("CCC");
			KeyBlock[3] = GetStringToArrayBuffer("DDDD");

			MasterSecret = GetStringToArrayBuffer(sMasterSecret);
			ClientMsg = GetStringToArrayBuffer(sClientMsg);

			for (var i=0; i<KeyBlock.length; i++) {
				// SHA1("A" + master_secret + Cleint_Message)
				TempData[0] = KeyBlock[i].concat(MasterSecret).concat(ClientMsg);
				TempData[1] = GetArrayBufferToString(TempData[0]);
				HashData = JS_CRYPT_Hash(this.Define.HASH_ALG_SHA1, TempData[1]);

				// MD5(master_secret + SHA1(..) )
				TempData[0] = GetStringToArrayBuffer(HashData.message.data);
				TempData[1] = MasterSecret.concat(TempData[0]);
				TempData[0] = GetArrayBufferToString(TempData[1]);
				HashData = JS_CRYPT_Hash(sAlgo, TempData[0]);

				// SHA256
				TempData[0] = HashData.message.data;
				HashData = JS_CRYPT_Hash(this.Define.HASH_ALG_SHA256, TempData[0]);
				TempData[1] = GetStringToArrayBuffer(HashData.message.data);

				TotalKeyBlock = TotalKeyBlock.concat(TempData[1]);
			}

			TempData = null;
			KeyBlock = GetArrayBufferToString(TotalKeyBlock);

			oResult = {code:0, message:KeyBlock};
		} catch (ex) {
			oResult = ex;
		}

		if (typeof(callback) == "function") {
			callback(oResult);
		}

		return oResult;
	}

	StringToArrayBuffer = function(value) {
		return GetStringToArrayBuffer(value);
	}

	ArrayBufferToString = function(value) {
		return GetArrayBufferToString(value);
	}

	IntegerToArrayBuffer = function(value, size) {
		return GetIntegerToArrayBuffer(value, size);
	}

	MakeKDF = function(data, key, iv, hashAlgo, callback) {
		var oResult = 0;

		try {
			if (data == null || typeof(data) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(data)"};
			}
			if (key == null || typeof(key) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(key)"};
			}
			if (iv == null || typeof(iv) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(iv)"};
			}
			if (hashAlgo == null || typeof(hashAlgo) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(hashAlgo)"};
			}

			var oDigest = JS_CRYPT_Hash(this.Define.HASH_ALG_SHA256, data);

			if (oDigest.code != 0) {
				throw oDigest;
			}

			var KeyArray   	  = GetStringToArrayBuffer(key);
			var IvArray  	  = GetStringToArrayBuffer(iv);
			var MasterSecret  = KeyArray.concat(IvArray);
			var ClientMsg	  = oDigest.message.data;
			var MasterSecretS = GetArrayBufferToString(MasterSecret);
			var	KeyBlock	  = MakeKeyBlock(hashAlgo, MasterSecretS, ClientMsg);

			if (KeyBlock.code != 0) {
				throw KeyBlock;
			}

			oResult = {code:0, message:KeyBlock.message};
		} catch (ex) {
			oResult = ex;
		}

		if (typeof(callback) == "function") {
			callback(oResult);
		}

		return oResult;
	}

	GetSessionKey = function(sSiteID, sAlgo, sKeyBlock, callback) {
		var oResult = 0;

		try {
			if (sAlgo == null || typeof(sAlgo) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(sAlgo)"};
			}

			if ((sAlgo === this.Define.SYM_ALG_3DES_CBC)) {
				throw {code:1004, message:"Not Support Algorithm " + sAlgo};
			}

			var SessionInfo = new Object();

			function encryptKeyblock(data) {
				var secretKey = magicjs.hex.decode("0098386c79537d3980b0de03ea1bac12");
				var iv = magicjs.hex.decode("85b1043e692444fe6232209bd917ccc3");

				var cipher = magicjs.cipher.create(true, "SEED-CBC", secretKey);
				cipher.init(iv);
				cipher.update(data);
				var encrypted = magicjs.base64.encode(cipher.finish());
				return encrypted;
			}

			function decryptKeyblock(data) {
				var secretKey = magicjs.hex.decode("0098386c79537d3980b0de03ea1bac12");
				var iv = magicjs.hex.decode("85b1043e692444fe6232209bd917ccc3");

				var cipher = magicjs.cipher.create(false, "SEED-CBC", secretKey);
				cipher.init(iv);
				cipher.update(magicjs.base64.decode(data));
				var decrypted = cipher.finish();
				return decrypted;
			}

			SessionInfo.SessionID = sSiteID;
			SessionInfo.KeyBlock  = encryptKeyblock(sKeyBlock);

			SessionInfo.getClientKey = function() {
				var KeyBlock  = decryptKeyblock(SessionInfo.KeyBlock);
				var KeyArray  = GetStringToArrayBuffer(KeyBlock.data);
				var resultKey = KeyArray.slice(0,  16);

				return resultKey;
			}
			SessionInfo.getClientIv  = function() {
				var KeyBlock  = decryptKeyblock(SessionInfo.KeyBlock);
				var KeyArray  = GetStringToArrayBuffer(KeyBlock.data);
				var resultKey = KeyArray.slice(16, 32);

				return resultKey;
			}
			SessionInfo.getServerKey = function() {
				var KeyBlock  = decryptKeyblock(SessionInfo.KeyBlock);
				var KeyArray  = GetStringToArrayBuffer(KeyBlock.data);
				var resultKey = KeyArray.slice(32, 48);

				return resultKey;
			}
			SessionInfo.getServerIv  = function() {
				var KeyBlock  = decryptKeyblock(SessionInfo.KeyBlock);
				var KeyArray  = GetStringToArrayBuffer(KeyBlock.data);
				var resultKey = KeyArray.slice(48, 64);

				return resultKey;
			}

			oResult = {code:0, message:SessionInfo};
		} catch (ex) {
			oResult = ex;
		}

		if (typeof(callback) == "function") {
			callback(oResult);
		}

		return oResult;
	}

	MakeKeyIV = function(sSiteID, symmetricAlgo, hashAlgo, data, callback) {
		var oResult = 0;

		try {
			if (sSiteID == null || typeof(sSiteID) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(sSiteID)"};
			}
			if (symmetricAlgo == null || typeof(symmetricAlgo) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(symmetricAlgo)"};
			}
			if (hashAlgo == null || typeof(hashAlgo) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(hashAlgo)"};
			}
			if (data == null || typeof(data) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(data)"};
			}

			var oContentInfo = JS_CRYPT_GetKeyAndIV();

			if (oContentInfo.code != 0) {
				throw oContentInfo;
			}

			var KeyBlock = MakeKDF(data, oContentInfo.message.key.data, oContentInfo.message.iv.data, hashAlgo);

			if (KeyBlock.code != 0) {
				throw KeyBlock;
			}

			var oSessionInfo = GetSessionKey(sSiteID, symmetricAlgo, KeyBlock.message);

			if (oSessionInfo.code != 0) {
				throw oSessionInfo;
			}

			oResult = {code:0, message:oSessionInfo.message};
		} catch (ex) {
			oResult = ex;
		}

		if (typeof(callback) == "function") {
			callback(oResult);
		}

		return oResult;
	}
	/////////////////////////////////////////////////////////////////////////////////////
	MakeSignContentInfo = function(oSignData, oRandom, callback) {
		var oResult = 0;

		try {
			if (oSignData == null || typeof(oSignData) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(oSignData)"};
			}
			if (oRandom == null || typeof(oRandom) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(oRandom)"};
			}

			var RandomL     = GetIntegerToArrayBuffer(oRandom.length, 2);
			var RandomV     = GetStringToArrayBuffer(oRandom);
			var SignDataL   = GetIntegerToArrayBuffer(oSignData.length, 4);
			var SignDataV   = GetStringToArrayBuffer(oSignData);
			var ContentInfo = RandomL.concat(RandomV).concat(SignDataL).concat(SignDataV);
			var ContentInfoS = GetArrayBufferToString(ContentInfo);

			oResult = {code:0, message:ContentInfoS};
		} catch (ex) {
			oResult = ex;
		}

		if (typeof(callback) == "function") {
			callback(oResult);
		}

		return oResult;
	}

	ParseContentInfo = function(oData, callback) {
		var oResult = 0;

		try {
			if (oData == null || typeof(oData) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(oData)"};
			}

			var RemoveTagInfo = oData.replace("<magicline:ENCRYPTED DATA>","").replace("</magicline:ENCRYPTED DATA>","");
			var ContentInfo   = JS_BASE64_Decode(RemoveTagInfo);

			if (ContentInfo.code != 0) {
				throw ContentInfo;
			}

			ContentInfo = GetStringToArrayBuffer(ContentInfo.message);

			var MajorVersion  = ContentInfo[0];
			var MinorVersion  = ContentInfo[1];
			var ContentType   = ContentInfo[2];
			var ContentLength = GetArrayBufferToInteger(ContentInfo.slice(3, 7));
			var ContentData   = ContentInfo.slice(7, 7+ContentLength);
			var ContentInfoS  = new Object();

			ContentInfoS.ContentType   = ContentType;
			ContentInfoS.ContentLength = ContentLength;
			ContentInfoS.ContentData   = GetArrayBufferToString(ContentData);

			oResult = {code:0, message:ContentInfoS};
		} catch (ex) {
			oResult = ex;
		}

		if (typeof(callback) == "function") {
			callback(oResult);
		}

		return oResult;
	}

	MakeContent = function(contentType, oData, callback) {
		var oResult = 0;

		try {
			if (contentType == null || typeof(contentType) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(contentType)"};
			}
			if (oData == null || typeof(oData) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(oData)"};
			}

			var ContentType = GetIntegerToArrayBuffer(contentType,  1);
			var DataLengthL = GetIntegerToArrayBuffer(oData.length, 4);
			var DataLengthV = GetStringToArrayBuffer(oData);
			var Content 	= ContentType.concat(DataLengthL).concat(DataLengthV);
			var ContentS 	= GetArrayBufferToString(Content);

			oResult = {code:0, message:ContentS};
		} catch (ex) {
			oResult = ex;
		}

		if (typeof(callback) == "function") {
			callback(oResult);
		}

		return oResult;
	}

	MakeBaseContentInfo = function(contentType, oData, callback) {
		var oResult			= 0;
		var nMajorVersion	= 1;
		var nMinorVersion 	= 0;

		try {
			if (contentType == null || typeof(contentType) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(contentType)"};
			}
			if (oData == null || typeof(oData) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(oData)"};
			}

			var HeaderMajor	 = GetIntegerToArrayBuffer(nMajorVersion, 1);
			var HeaderMinor  = GetIntegerToArrayBuffer(nMinorVersion, 1);
			var Content 	 = MakeContent(contentType, oData);
			var ContentV 	 = GetStringToArrayBuffer(Content.message);
			var ContentInfo	 = HeaderMajor.concat(HeaderMinor).concat(ContentV);
			var ContentInfoS = GetArrayBufferToString(ContentInfo);

			oResult = {code:0, message:ContentInfoS};
		} catch (ex) {
			oResult = ex;
		}

		if (typeof(callback) == "function") {
			callback(oResult);
		}

		return oResult;
	}

	MakeContentInfo = function(contentType, oData, callback) {
		var oResult = 0;

		try {
			if (contentType == null || typeof(contentType) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(contentType)"};
			}
			if (oData == null || typeof(oData) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(oData)"};
			}

			var BaseContentInfo = MakeBaseContentInfo(contentType, oData);
			var ContentSTag		= "<magicline:ENCRYPTED DATA>";
			var ContentData		= magicjs.base64.encode(BaseContentInfo.message);
			var ContentETag		= "</magicline:ENCRYPTED DATA>";
			var message			= ContentSTag.concat(ContentData).concat(ContentETag);

			oResult = {code:0, message:message};
		} catch (ex) {
			oResult = ex;
		}

		if (typeof(callback) == "function") {
			callback(oResult);
		}

		return oResult;
	}

	JS_CMS_MakeEnvelopedData = function(sKMCert, sAlgo, oEnvelopOpt, sPlainText, callback) {
		var oResult  	  = 0;
		var envelopData	  = new Object();
		var envelopOption = new Object();

		this.mContentInfo = null;

		try {
			if (sKMCert == null || typeof(sKMCert) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(sKMCert)"};
			}
			if (sAlgo == null || typeof(sAlgo) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(sAlgo)"};
			}
			if (sPlainText == null || typeof(sPlainText) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(sPlainText)"};
			}

			if (!(sAlgo.toLowerCase() === this.Define.SYM_ALG_3DES_CBC
					|| sAlgo.toLowerCase() === this.Define.SYM_ALG_SEED_CBC
					|| sAlgo.toLowerCase() === this.Define.SYM_ALG_ARIA_CBC
					|| sAlgo.toLowerCase() === this.Define.SYM_ALG_ARIA_192BIT_CBC
					|| sAlgo.toLowerCase() === this.Define.SYM_ALG_ARIA_256BIT_CBC
					|| sAlgo.toLowerCase() === this.Define.SYM_ALG_AES_CBC
					|| sAlgo.toLowerCase() === this.Define.SYM_ALG_AES_192BIT_CBC
					|| sAlgo.toLowerCase() === this.Define.SYM_ALG_AES_256BIT_CBC)) {
				throw {code:1004, message:"Not Support Algorithm " + sAlgo};
			}

			var x509KMCert		= magicjs.x509Cert.create(sKMCert);
			var envelopData		= magicjs.pkcs7.envelopedData.create();
			envelopData.content = sPlainText;

			// 서명 알고리즘 설정
			if (oEnvelopOpt != null && typeof(oEnvelopOpt) != "undefined" && typeof(oEnvelopOpt.ds_pki_rsa) != "undefined") {
				if (oEnvelopOpt.ds_pki_rsa == this.Define.PKI_RSA_2_0) {
					envelopOption.scheme = this.Define.PKI_RSA_2_0_ENVELOP;
				} else {
					envelopOption.scheme = this.Define.PKI_RSA_1_5_STRING;
				}
			} else {
				envelopOption.scheme = this.Define.PKI_RSA_1_5_STRING;
			}

			if (envelopOption.scheme === this.Define.PKI_RSA_2_0_ENVELOP) {
				// 해시 알고리즘 설정 (CertHash, SHA1, SHA256)
				if (oEnvelopOpt != null && typeof(oEnvelopOpt) != "undefined" && typeof(oEnvelopOpt.ds_pki_hash) != "undefined") {
					if (oEnvelopOpt.ds_pki_hash !== this.Define.HASH_ALG_CERT) {
						envelopOption.md = oSignOpt.ds_pki_hash;
					}
				}
			}

			var contentEncAlgo = sAlgo + "-CBC";

			envelopData.addRecipient(x509KMCert, envelopOption);
			envelopData.encrypt(contentEncAlgo);

			this.mContentInfo = new Object();
			Object.assign(this.mContentInfo, envelopData.contentEncInfo);

			oResult = {code:0, message:envelopData};

		} catch (ex) {
			oResult = ex;
		}

		if (typeof(callback) == "function") {
			callback(oResult);
		}

		return oResult;
	}

	JS_CRYPT_GetKeyAndIV = function(callback) {
		var oResult = 0;

		try {
			if (this.mContentInfo == null || typeof(this.mContentInfo) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(mContentInfo)"};
			}

			oResult = {code:0, message:this.mContentInfo};
		} catch (ex) {
			oResult = ex;
		}

		if (typeof(callback) == "function") {
			callback(oResult);
		}

		return oResult;
	}

	JS_CRYPT_Encrypt = function(sAlgo, sKey, sIv, sPlainText, callback) {
		var oResult = 0;

		try {
			if (sAlgo == null || typeof(sAlgo) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(sAlgo)"};
			}
			if (sKey == null || typeof(sKey) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(sKey)"};
			}
			if (sIv == null || typeof(sIv) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(sIv)"};
			}
			if (sPlainText == null || typeof(sPlainText) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(sPlainText)"};
			}

			var cipherAlgo = sAlgo.toUpperCase() + "-CBC";

			var cipher = magicjs.cipher.create(true, cipherAlgo, sKey);
			cipher.init(sIv);
			cipher.update(sPlainText);
			var encrypted = cipher.finish();

			oResult = {code:0, message:encrypted};
		} catch (ex) {
			oResult = ex;
		}

		if (typeof(callback) == "function") {
			callback(oResult);
		}

		return oResult;
	}

	JS_CRYPT_Decrypt = function(sAlgo, sKey, sIv, sCipherText, callback) {
		var oResult = 0;

		try {
			if (sAlgo == null || typeof(sAlgo) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(sAlgo)"};
			}
			if (sKey == null || typeof(sKey) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(sKey)"};
			}
			if (sIv == null || typeof(sIv) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(sIv)"};
			}
			if (sCipherText == null || typeof(sCipherText) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(sCipherText)"};
			}

			var cipherAlgo = sAlgo.toUpperCase() + "-CBC";

			var cipher = magicjs.cipher.create(false, cipherAlgo, sKey);
			cipher.init(sIv);
			cipher.update(sCipherText);
			var decrypted = cipher.finish();

			oResult = {code:0, message:decrypted};
		} catch (ex) {
			oResult = ex;
		}

		if (typeof(callback) == "function") {
			callback(oResult);
		}

		return oResult;
	}

	JS_BASE64_Decode = function(sEncData, callback) {
		var oResult = 0;

		try {
			if (sEncData == null || typeof(sEncData) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(sEncData)"};
			}

			var b64decode = magicjs.base64.decode(sEncData);

			oResult = {code:0, message:b64decode};
		} catch (ex) {
			oResult = ex;
		}

		if (typeof(callback) == "function") {
			callback(oResult);
		}

		return oResult;
	}

	JS_CRYPT_Hash = function(sAlgo, sTBHData, callback) {
		var oResult = 0;

		try {
			if (sAlgo == null || typeof(sAlgo) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(sAlgo)"};
			}
			if (sTBHData == null || typeof(sTBHData) == "undefined") {
				throw {code:1004, message:"The input is invalid type.(sTBHData)"};
			}

			if (!(sAlgo === this.Define.HASH_ALG_SHA1
					|| sAlgo === this.Define.HASH_ALG_SHA256
					|| sAlgo === this.Define.HASH_ALG_SHA512)) {
				throw {code:1004, message:"Not Support Algorithm " + sAlgo};
			}

			var oDigest = magicjs.md.create(sAlgo);

			oDigest.init();
			oDigest.update(sTBHData);
			var sDigest = oDigest.digest();

			oResult = {code:0, message:sDigest};
		} catch (ex) {
			oResult = ex;
		}

		if (typeof(callback) == "function") {
			callback(oResult);
		}

		return oResult;
	}
	return {

		Define : Define,
		isLicense : function() {
			if (mLicenseFlag == false) {
				throw {code:MLVKeyErrCode.AXERR_LICENSEEXPIRED.code, message:MLVKeyErrCode.AXERR_LICENSEEXPIRED.message};
			}

			return mLicenseFlag;
		},
		setLicense : function(license) {
			try {
				var oPublicKey = magicjs.pubKey.create('MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKO/uO5kOFbMejccZAYgIYPiqKvUQ2X5dR5CrhBKKQutfiju5OuOm9TOnk96FeTGowPTo+IvXtO+ATIsJGB5MVkCAwEAAQ==');
				var oCipherObj = "";
				var decryptedData = "";

				if (typeof(license) != "string") {
					throw {code:MLVKeyErrCode.AXERR_LICENSEEXPIRED.code, message:MLVKeyErrCode.AXERR_LICENSEEXPIRED.message};
				}

				if (license.length < 90) {
					throw {code:MLVKeyErrCode.AXERR_LICENSEEXPIRED.code, message:MLVKeyErrCode.AXERR_LICENSEEXPIRED.message};
				}

				var sCipherKey  = license.substring(0, 88);
				var sCipherData = license.substring(88);

				sCipherKey = magicjs.base64.decode(sCipherKey);
				sCipherKey = oPublicKey.decrypt(sCipherKey);

				sCipherData = magicjs.base64.decode(sCipherData);
				oCipherObj  = JS_CRYPT_Decrypt("SEED", sCipherKey, sCipherKey, sCipherData);

				if (oCipherObj.code != 0) {
					throw {code:MLVKeyErrCode.AXERR_LICENSEEXPIRED.code, message:MLVKeyErrCode.AXERR_LICENSEEXPIRED.message};
				}

				decryptedData = oCipherObj.message.data;

				if (decryptedData.length <= 1) {
					throw {code:MLVKeyErrCode.AXERR_LICENSEEXPIRED.code, message:MLVKeyErrCode.AXERR_LICENSEEXPIRED.message};
				}

				if (decryptedData.substring(0,1).toLowerCase() == "t") {
					var dateTime = decryptedData.substring(1);
					var sdt = new Date();
					var edt = new Date(dateTime);
					var dateDiff = Math.ceil(edt.getTime()-sdt.getTime());

					if (dateDiff <= 0) {
						throw {code:MLVKeyErrCode.AXERR_LICENSEEXPIRED.code, message:MLVKeyErrCode.AXERR_LICENSEEXPIRED.message};
					}

					mLicenseFlag = true;
				} else if (decryptedData.substring(0,1).toLowerCase() == "r") {
					var info = decryptedData.split('|');

					if (info.length < 4) {
						throw {code:MLVKeyErrCode.AXERR_LICENSEEXPIRED.code, message:MLVKeyErrCode.AXERR_LICENSEEXPIRED.message};
					}

					if (info[1].indexOf("magicVkeyboard") < 0) {
						throw {code:MLVKeyErrCode.AXERR_LICENSEEXPIRED.code, message:MLVKeyErrCode.AXERR_LICENSEEXPIRED.message};
					}

					var domainName  = info[0].substring(1);
					var domainNames = domainName.split('$');

					if (domainNames.length == 0) {
						throw {code:MLVKeyErrCode.AXERR_LICENSEEXPIRED.code, message:MLVKeyErrCode.AXERR_LICENSEEXPIRED.message};
					}

					function isValidHost(address){
						var hostName = window.location.hostname.split('.');
						var hostTemp = address.split(".");

						for (var x in hostTemp) {
							if (hostTemp[x] == "") {
								hostTemp.splice(x,1);
							}
						}

						if (hostName.length != hostTemp.length) {
							return false;
						}

						for (var i in hostTemp) {
							if ( (!hostName[i]) || (hostName[i].toLowerCase() != hostTemp[i].toLowerCase()) ) {
								if (hostTemp[i] != "*") {
									return false;
								}
							}
						}

						return true;
					}

					for (var idx in domainNames) {
						var isValid = isValidHost(domainNames[idx]);

						if (isValid == true) {
							mLicenseFlag = true;
							break;
						}
					}

					if (mLicenseFlag == false) {
						throw {code:MLVKeyErrCode.AXERR_LICENSEEXPIRED.code, message:MLVKeyErrCode.AXERR_LICENSEEXPIRED.message};
					}
				}
			} catch (ex) {
				throw ex;
			}
		},
		EnvelopData : function(sChallenge, sServerCert, data, callback) {
			var oResult       = new Object();
			var envelopOpt	  = { ds_pki_rsa: Define.PKI_RSA_1_5 };
			var symAlgo		  = 'SEED/CBC';
			var SymmetricAlgo = symAlgo.split('/')[0]; // * 대칭키 암호화 알고리즘 지정 (3:SEED, 5:ARIA. 그 외의 알고리즘은 사용 안함)
			var HashAlgo      = 'SHA256'

			try {
				this.isLicense();

				// 세션 초기화
				if (typeof(this.mSessionInfo) != "undefined" && this.mSessionInfo != null) {
					delete this.mSessionInfo;
				}

				this.mSessionInfo = new Object();

				var toBeEnvelopData =  String.format('challenge={0}$algo={1}$data={2}', sChallenge, symAlgo, data);

				// 원본데이터의 해쉬값 생성
				var oDigest = JS_CRYPT_Hash(Define.HASH_ALG_SHA256, toBeEnvelopData);

				if (oDigest.code != 0) {
					throw {code: MLVKeyErrCode.AXERR_HASH_FAIL.code, message: MLVKeyErrCode.AXERR_HASH_FAIL.message};
				}

				// data + hash(sha256)
				var dataArray  = StringToArrayBuffer(toBeEnvelopData);
				var dataDigest = StringToArrayBuffer(oDigest.message.data);
				var TBEData	   = ArrayBufferToString(dataArray.concat(dataDigest));

				//전자봉투
				var oEnvelopData = JS_CMS_MakeEnvelopedData(sServerCert, SymmetricAlgo, envelopOpt, TBEData);

				if (oEnvelopData.code != 0) {
					throw {code: MLVKeyErrCode.AXERR_ENCRYPT_FAIL.code, message: MLVKeyErrCode.AXERR_ENCRYPT_FAIL.message};
				}

				// Make Content
				var oEnvelopMessage = oEnvelopData.message.toDer().data;
				var oEnvContentInfo = MakeContentInfo(this.Define.ENVELOP_DATA, oEnvelopMessage)

				if (oEnvContentInfo.code != 0) {
					throw {code: MLVKeyErrCode.AXERR_ENCRYPT_FAIL.code, message: MLVKeyErrCode.AXERR_ENCRYPT_FAIL.message};
				}

				// KDF
				var oKDF = MakeKeyIV(sChallenge, SymmetricAlgo, HashAlgo, oEnvelopMessage);

				if (oKDF.code != 0) {
					throw {code: MLVKeyErrCode.AXERR_MAKEKDF_FAIL.code, message: MLVKeyErrCode.AXERR_MAKEKDF_FAIL.message};
				}

				// 세션 설정
				Object.assign(this.mSessionInfo, oKDF.message);

				oResult = {code:0, message:oEnvContentInfo.message};
			} catch (ex) {
				oResult = ex;
			}

			if (typeof(callback) == "function") {
				Object.assign(callback, oResult);
			}

			return oResult;
		},
		Encrypt : function(sChallenge, sData, sType, callback) {
			var symAlgo = 'SEED/CBC';
			var oResult = 0;

			try {
				this.isLicense();

				if (sChallenge == null || typeof(sChallenge) == "undefined") {
					throw {code: MLVKeyErrCode.AXERR_INVALIDINPUT.code, message:"The input is invalid type.(sChallenge)"};
				}
				if (sData == null || typeof(sData) == "undefined") {
					throw {code: MLVKeyErrCode.AXERR_INVALIDINPUT.code, message:"The input is invalid type.(sData)"};
				}
				if (typeof(this.mSessionInfo) == "undefined" || this.mSessionInfo == null) {
					throw {code: MLVKeyErrCode.AXERR_INVALIDINPUT.code, message:"The input is invalid type.(mSessionInfo)"};
				}

				var oSessionInfo = this.mSessionInfo

				if (typeof(oSessionInfo.getClientKey) == "undefined" || typeof(oSessionInfo.getClientIv) == "undefined" ) {
					throw {code: MLVKeyErrCode.AXERR_NOTEXISTSESSIONINFO.code, message: MLVKeyErrCode.AXERR_NOTEXISTSESSIONINFO.message};
				}

				// 원본데이터의 해쉬값 생성
				var toBeEncryptData =  String.format('challenge={0}$data={1}$dataType={2}', sChallenge, sData, sType);
				var oDigest = JS_CRYPT_Hash(Define.HASH_ALG_SHA256, toBeEncryptData);

				if (oDigest.code != 0) {
					throw {code: MLVKeyErrCode.AXERR_HASH_FAIL.code, message: MLVKeyErrCode.AXERR_HASH_FAIL.message};
				}

				// data + hash(sha256)
				var dataArray  = StringToArrayBuffer(toBeEncryptData);
				var dataDigest = StringToArrayBuffer(oDigest.message.data);
				var TBEData	   = ArrayBufferToString(dataArray.concat(dataDigest));

				// 암호화
				var SymmetricAlgo = symAlgo.split("/")[0];
				var ClientKey = ArrayBufferToString(oSessionInfo.getClientKey());
				var ClientIv  = ArrayBufferToString(oSessionInfo.getClientIv());
				var oEncrypt  = JS_CRYPT_Encrypt(SymmetricAlgo, ClientKey, ClientIv, TBEData);

				if (oEncrypt.code != 0) {
					throw {code: MLVKeyErrCode.AXERR_ENCRYPT_FAIL.code, message: MLVKeyErrCode.AXERR_ENCRYPT_FAIL.message};
				}

				// Make Content
				var oEncContentInfo = MakeContentInfo(Define.ENCRYPTED_DATA, oEncrypt.message.data);

				if (oEncContentInfo.code != 0) {
					throw {code: MLVKeyErrCode.AXERR_MAKEMSG_FAIL.code, message: MLVKeyErrCode.AXERR_MAKEMSG_FAIL.message};
				}

				oResult = {code:0, message:oEncContentInfo.message};
			} catch (ex) {
				oResult = ex;
			}

			if (typeof(callback) == "function") {
				Object.assign(callback, oResult);
			}

			return oResult;
		},
		Decrypt : function(sData, callback) {
			var symAlgo = 'SEED/CBC';
			var oResult = new Object();

			try {
				this.isLicense();

				if (sData == null || typeof(sData) == "undefined") {
					throw {code: MLVKeyErrCode.AXERR_INVALIDINPUT.code, message:"The input is invalid type.(sData)"};
				}
				if (typeof(this.mSessionInfo) == "undefined" || this.mSessionInfo == null) {
					throw {code: MLVKeyErrCode.AXERR_INVALIDINPUT.code, message:"The input is invalid type.(mSessionInfo)"};
				}

				var oSessionInfo = this.mSessionInfo

				if (typeof(oSessionInfo.getServerKey) == "undefined" || typeof(oSessionInfo.getServerIv) == "undefined" ) {
					throw {code: MLVKeyErrCode.AXERR_NOTEXISTSESSIONINFO.code, message: MLVKeyErrCode.AXERR_NOTEXISTSESSIONINFO.message};
				}

				// Parse Content
				var oContentInfo = ParseContentInfo(sData);

				if (oContentInfo.code != 0) {
					throw {code: MLVKeyErrCode.AXERR_PARSEMSG_FAIL.code, message: MLVKeyErrCode.AXERR_PARSEMSG_FAIL.message};
				}

				var ContentInfo = oContentInfo.message;

				if (ContentInfo.ContentType != Define.ENCRYPTED_DATA) {
					throw {code: MLVKeyErrCode.AXERR_INVALID_DATA.code, message: MLVKeyErrCode.AXERR_INVALID_DATA.message};
				}

				// 복호화
				var SymmetricAlgo = symAlgo.split("/")[0];
				var ServerKey  = ArrayBufferToString(oSessionInfo.getServerKey());
				var ServerIv   = ArrayBufferToString(oSessionInfo.getServerIv());
				var CipherData = ContentInfo.ContentData;
				var oDecrypt   = JS_CRYPT_Decrypt(SymmetricAlgo, ServerKey, ServerIv, CipherData);

				if (oDecrypt.code != 0) {
					throw {code: MLVKeyErrCode.AXERR_DECRYPT_FAIL.code, message: MLVKeyErrCode.AXERR_DECRYPT_FAIL.message};
				}

				// data + hash(sha256) 분리
				var ContentData = StringToArrayBuffer(oDecrypt.message.data);
				var PlainText   = ArrayBufferToString(ContentData.slice(0, ContentData.length-32));
				var HashData    = ArrayBufferToString(ContentData.slice(ContentData.length-32, ContentData.length));

				var oDigest = JS_CRYPT_Hash(Define.HASH_ALG_SHA256, PlainText);

				if (oDigest.code != 0) {
					throw {code: MLVKeyErrCode.AXERR_HASH_FAIL.code, message: MLVKeyErrCode.AXERR_HASH_FAIL.message};
				}

				if (!(HashData === oDigest.message.data)) {
					throw {code: MLVKeyErrCode.AXERR_INVALIDHASH_FAIL.code, message: MLVKeyErrCode.AXERR_INVALIDHASH_FAIL.message};
				}

				oResult = {code:0, message:PlainText};
			} catch (ex) {
				oResult = ex;
			}

			if (typeof(callback) == "function") {
				Object.assign(callback, oResult);
			}

			return oResult;
		}
	}
}());

var ML4WebVKey    = (function() {
	var ticking       = false;
	var ML4WebVKeyPad = null;
	// 제한 입력 개수 오버 여부
	var limitOver	  = true;
	var limitOverCount= -1;
	// MLStatusCode 상태 코드
	// 		- 정상 : 			loading(0),
	// 		- 정상 진행중 : 	loading completed(1), createKeyboard completed(2),
	// 		- 실패 : 			loading failed(-1),  createKeyboard failed(-2)
	var MLStatusCode = 0;

	var MLVKeyUtils = {
		getAttributeByElementTag : function(elementTag, attribute) {
			var inputs = document.getElementsByTagName(elementTag);
			var items  = new Array();

			try {
				for (var i=0; i<inputs.length; i++) {
					var input = inputs.item(i);

					if ((input.getAttribute(attribute) != null)) {
						items.push(input);
					}
				}
			} catch (ex) {
				throw {code: MLVKeyErrCode.AXERR_API_SCRIPT.code, message: MLVKeyErrCode.AXERR_API_SCRIPT.message + "(getAttributeByElementTag)"};
			}

			return items;
		},
		insertAfter : function (referenceNode, newNode) {
			if (!!referenceNode.nextSibling) {
				referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
			} else {
				referenceNode.parentNode.appendChild(newNode);
			}
		},
		isIEDesktop : function(){
			var result = ((/MSIE (\d+\.\d+);/.test(navigator.userAgent) || navigator.userAgent.indexOf("Trident/") > -1) && window.outerWidth > 1023 );

			return result;
		},
		isDesktopOS : function(){
			var result = ( 'win16|win32|win64|windows|mac|macintel|linux|freebsd|openbsd|sunos'.indexOf(navigator.platform.toLowerCase()) >= 0 );

			return result;
		},
		isMobileDevice : function(){
			var target = '';
			var useragent = navigator.userAgent.toLowerCase();
			var devices = ['iphone', 'ipod', 'ipad', 'android', 'blackberry', 'windows ce', 'nokia', 'webos', 'opera mini', 'samsung', 'lg', 'mi', 'sonyericsson',  'opera mobi', 'iemobile', 'huawei', 'oppo', 'mot'];

			devices.forEach(function(device){
				if(useragent.indexOf(device) >= 0) {
					target = device;
				}
			});

			if (target.length == 0) {
				return false
			} else {
				return true;
			}
		},
		isAccessiblity : function(){
			return MLVKeyConfig.accessibility;
		},
		getMobileDevice : function(){
			var target = '';
			var useragent = navigator.userAgent.toLowerCase();
			var devices = ['iphone', 'ipod', 'ipad', 'android', 'blackberry', 'windows ce', 'nokia', 'webos', 'opera mini', 'samsung', 'lg', 'mi', 'sonyericsson',  'opera mobi', 'iemobile', 'huawei', 'oppo', 'mot'];

			devices.forEach(function(device){
				if(useragent.indexOf(device) >= 0) {
					target = device;
				}
			});

			return target;
		},
		getPadDigits : function(n, width, z) {
			z = z || '0';
			n = n + '';
			return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
		}
	}
	var MLVKeyErrCode = {AXERR_OK:	0
		, AXERR_LICENSEEXPIRED			: {code: 30000,	message: '라이센스 정보(만료일 또는 도메인)를 확인하시기 바랍니다.'}
		, AXERR_NOTSETPROPERTY 			: {code: 30001,	message: '초기화 설정에 실패하였습니다.'}
		, AXERR_INVALIDINPUT 			: {code: 30002,	message: '입력받은 데이터가 올바르지 않습니다.'}
		, AXERR_FAILINITALIZE 			: {code: 30003,	message: '초기화에 실패했습니다.'}
		// 암호화 관련
		, AXERR_NOTSERVERCERT			: {code: 30050,	message: '웹서버로부터 다운받은 서버인증서가 없습니다.'}
		, AXERR_MAKESESSIONID_FAIL		: {code: 30052,	message: '세션정보 생성에 실패하였습니다. 첫번째 서버호출을 확인하세요.'}
		, AXERR_NOTEXISTSESSIONINFO		: {code: 30053,	message: '세션정보가 존재하지 않습니다.로그인후에 다시 이용하십시오.'}
		, AXERR_ENCRYPT_FAIL			: {code: 30055,	message: '메세지 암호화에 실패하였습니다.'}
		, AXERR_DECRYPT_FAIL			: {code: 30056,	message: '메세지 복호화에 실패하였습니다.'}
		, AXERR_HASH_FAIL				: {code: 30057,	message: '데이터의 해시 생성에 실패하였습니다. 인증서 설정값 확인하십시오.'}
		, AXERR_INVALIDHASH_FAIL		: {code: 30058,	message: '데이터 무결성 오류(해쉬값이 일치하지 않습니다)'}
		, AXERR_MAKEKDF_FAIL			: {code: 30059,	message: '서버와 암/복호화시 사용될 통신키 생성에 실패하였습니다.'}
		, AXERR_MAKEMSG_FAIL			: {code: 30060,	message: '서버로 전송할 암호화 메세지 생성에 실패하였습니다.'}
		, AXERR_PARSEMSG_FAIL			: {code: 30061,	message: '서버로부터 전송받은 메세지가 올바르지 않습니다.'}
		, AXERR_INVALID_DATA			: {code: 30062,	message: '입력받은 데이터가 올바르지 않습니다.'}
		// 기타오류
		, AXERR_API_SCRIPT				: {code: 40000,	message: '스크립트에 오류가 발생하였습니다.'}
	}
	var MLServlet = {
		ajaxType : 0,
		isJsonp : function(url) {
			var servletUrl  = url.match(/([a-zA-Z]+):\/\/([\-\w\.]+)(?:\:(\d{0,5}))?/);
			var locationUrl = window.location.href.match(/([a-zA-Z]+):\/\/([\-\w\.]+)(?:\:(\d{0,5}))?/);

			if (servletUrl == null) {
				return false;
			}

			if (locationUrl == null) {
				return true;
			}

			// [1] protocol
			if (locationUrl[1] != servletUrl[1]) {
				return true;
			}

			// [2] url
			if (locationUrl[2] != servletUrl[2]) {
				return true;
			}

			// [3] port
			if (locationUrl.length != servletUrl.length) {
				return true;
			}

			if (locationUrl[3] != servletUrl[3]) {
				return true;
			}

			return false;
		},
		jsonp : function(url, data, callback) {
			if (typeof($) == "undefined") {
				var script       = document.createElement('script');
				var callbackName = 'jsonpCallback' + Math.round(10000000000000000000 * Math.random()) + '_' + Math.round(1000000000000 * Math.random());

				window[callbackName] = function(data) {
					delete window[callbackName];
					document.getElementsByTagName('head')[0].removeChild(script);
					callback(data);
					return;
				}

				script.type  = "text/javascript";
				script.async = true;
				script.src   = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'callback=' + callbackName + '&' + data;

				document.getElementsByTagName('head')[0].appendChild(script);
			} else {
				$.ajax({
					url:      url,
					data:     data,
					type:     "POST",
					cache:    false,
					dataType: "jsonp",
					success: function(responseText){
						callback(responseText);
					},
					error: function (responseText, status, error){
						callback(responseText);
					}
				});
			}
		},
		secureAjax : function(url, data, callback, custom) {
			var message = "";
			var requrl  = MLVKeyConfig.servlet;
			var reqdata = encodeURIComponent(magicjs.base64.encode(data));
			var result  = "";

			if (ML4WebVKeyPad == null || typeof(ML4WebVKeyPad.mToken) == "undefined" || ML4WebVKeyPad.mToken == "") {
				message = String.format('op=exchangeData&encryptedData={0}', reqdata);
			} else {
				message = String.format('op=exchangeData&encryptedData={0}&token={1}', reqdata, encodeURIComponent(ML4WebVKeyPad.mToken));
			}

			if (typeof(custom) != "undefined") {
				message = String.format('{0}&etc={1}', message, encodeURIComponent(custom));
			}

			if (typeof(url) != "undefined") {
				requrl = url;
			}

			if (typeof(callback) != "undefined" && typeof(callback) == "function") {
				MLServlet.sendAsync(requrl, message, callback);
			} else {
				result = MLServlet.sendSync(requrl, message);
			}

			return result;
		},
		secureAjaxMessage : function(data, custom) {
			var message = "";
			var reqdata = encodeURIComponent(magicjs.base64.encode(data));

			if (ML4WebVKeyPad == null || typeof(ML4WebVKeyPad.mToken) == "undefined" || ML4WebVKeyPad.mToken == "") {
				message = String.format('op=exchangeData&encryptedData={0}', reqdata);
			} else {
				message = String.format('op=exchangeData&encryptedData={0}&token={1}', reqdata, encodeURIComponent(ML4WebVKeyPad.mToken));
			}

			if (typeof(custom) != "undefined") {
				message = String.format('{0}&etc={1}', message, encodeURIComponent(custom));
			}

			return message;
		},
		sendSync : function(url, data, callback) {
			var request = new XMLHttpRequest();
			request.open("POST", url, false);
			request.setRequestHeader("Cache-Control", "no-cache");
			request.setRequestHeader("Content-type",  "application/x-www-form-urlencoded");

			try {
				request.send(data);

				if (request.readyState==4 && request.status==200) {
					if (typeof(callback) != "undefined" && typeof(callback) == "function") {
						callback(JSON.parse(request.responseText));
					} else {
						return JSON.parse(request.responseText);
					}
				} else {
					if (typeof(callback) != "undefined" && typeof(callback) == "function") {
						callback({code: -1, message: "XMLHttpRequest error"});
					} else {
						return {code: -1, message: "XMLHttpRequest error"};
					}
				}
			} catch(e) {
				if (typeof(callback) == "function") {
					callback({code: -2, message: "XMLHttpRequest error"});
				} else {
					return {code: -2, message: "XMLHttpRequest error"};
				}
			}
		},
		sendAsync : function(url, data, callback) {
			if (MLServlet.ajaxType == 0) {
				if (typeof($) == "undefined") {
					var request = new XMLHttpRequest();
					request.open("POST", url, true);
					request.setRequestHeader("Content-type",  "application/x-www-form-urlencoded");

					try {
						request.send(data);

						request.onreadystatechange = function() {
						}
						request.onload = function() {
							callback(JSON.parse(request.responseText));
						}
						request.onerror = function(e) {
							callback({code: -1, message: "'Network request failed'"});
						}
					} catch(e) {
						callback({code: -1, message: "'Network request failed'"});
					}
				} else {
					$.ajax({
						url:      url,
						data:     data,
						type:     "POST",
						cache:    false,
						dataType: "json",
						success: function(responseText){
							callback(responseText);
						},
						error: function (responseText, status, error){
							//MLServlet.ajaxType = 1;
							//MLServlet.jsonp(url, data, callback);
							callback({code: -1, message: "'Network request failed'"});
						}
					});
				}
			} else {
				MLServlet.jsonp(url, data, callback);
			}
		},
		setSessionKey : function(sessionTimeout, initParam, callback) {
			var message = String.format('op=setSessionKey&sessionTimeout={0}&initParam={1}', sessionTimeout, initParam);
			var result  = "";

			if (typeof(callback) != "undefined" && typeof(callback) == "function") {
				MLServlet.sendAsync(MLVKeyConfig.servlet, message, function(result) {
					if (typeof(result.code) == "undefined") {
						callback({code: 1004, message: "not defined code"});
					}
					if (typeof(result.message) == "undefined") {
						callback({code: 1004, message: "not defined message"});
					}
					callback(result);
				});
			} else {
				result = MLServlet.sendSync(MLVKeyConfig.servlet, message);

				try {
					if (typeof(result.code) == "undefined") {
						throw {code: 1004, message: "not defined code"};
					}
					if (typeof(result.message) == "undefined") {
						throw {code: 1004, message: "not defined message"};
					}
				} catch (ex) {
					result = ex;
				}
			}

			return result;
		},
		secureRequest : function(data, callback, token) {
			var message = "";
			var reqdata = encodeURIComponent(magicjs.base64.encode(data));
			var result  = "";

			if (typeof(token) == "undefined" || (typeof(token) == "string") && token.length == 0) {
				message = String.format('op=exchangeData&encryptedData={0}', reqdata);
			} else {
				message = String.format('op=exchangeData&encryptedData={0}&token={1}', reqdata, encodeURIComponent(token));
			}

			if (typeof(callback) != "undefined" && typeof(callback) == "function") {
				MLServlet.sendAsync(MLVKeyConfig.servlet, message, callback);
			} else {
				result = MLServlet.sendSync(MLVKeyConfig.servlet, message);
			}

			return result;
		},
		getSecureKeyboard : function(challenge, type, func, x, y, callback, token) {
			var message = "";
			var result  = "";

			if (typeof(token) == "undefined" || (typeof(token) == "string") && token.length == 0) {
				message = String.format('op=getSecureKeyboard&challenge={0}&type={1}&func={2}&x={3}&y={4}', challenge, type, func, x, y);
			} else {
				message = String.format('op=getSecureKeyboard&challenge={0}&type={1}&func={2}&x={3}&y={4}&token={5}', challenge, type, func, x, y, encodeURIComponent(token));
			}

			if (typeof(callback) != "undefined" && typeof(callback) == "function") {
				MLServlet.sendAsync(MLVKeyConfig.servlet, message, callback);
			} else {
				result = MLServlet.sendSync(MLVKeyConfig.servlet, message);
			}

			return result;
		}
	}

	function magicVKeyPadObject(inputObject, div, keyboardType, isMultiCursor) {
		this.mKeyType			= "";
		this.mKeyFlag			= "";
		this.mCapsLock			= "";
		this.mMultiCursor       = isMultiCursor;
		this.mKeyboard			= null;
		this.mKeyboardType		= keyboardType;
		this.mKeyboardLayouts	= ["qwerty", "number"];
		this.mKeyboardPosition  = [0,0];
		this.mEncryptedPassword = "";
		this.inputField         = document.getElementById(inputObject.id);
		this.hiddenField        = document.getElementById(inputObject.id + "_hiddenField");
		this.layoutDiv	        = div;
		this.mainDiv            = div.children[inputObject.id + "_mainDiv"];
		this.layoutLowerDiv     = div.children[inputObject.id + "_layoutLowerDiv"];
		this.layoutUpperDiv     = div.children[inputObject.id + "_layoutUpperDiv"];
		this.layoutOtherDiv     = div.children[inputObject.id + "_layoutOtherDiv"];
		this.multiMouseTypeDiv  = div.children[inputObject.id + "_multiMouseTypeDiv"];
		this.singleMouseTypeDiv = div.children[inputObject.id + "_singleMouseTypeDiv"];
		this.closeLayout		= div.children[inputObject.id + "_closeLayout"];
		this.divs				= [this.mainDiv, this.layoutLowerDiv, this.layoutUpperDiv, this.multiMouseTypeDiv, this.singleMouseTypeDiv, this.closeLayout];
		this.mCursor			= "";


		if (typeof(this.layoutLowerDiv) != "undefined") {
			this.layoutLowerDiv.style.display = "none";
		}
		if (typeof(this.layoutUpperDiv) != "undefined") {
			this.layoutUpperDiv.style.display = "none";
		}

		function VKT() {
			this.keyname  = "";
			this.pointidx = 0;
			this.pointx  = new Array();
			this.pointy  = new Array();
			this.pushPoint = function(x, y) {
				this.pointidx++;
				this.pointx.push(x);
				this.pointy.push(y);
			};
			this.contains = function(x, y) {
				var hits = 0;
				var lastx = this.pointx[this.pointidx - 1];
				var lasty = this.pointy[this.pointidx - 1];
				var curx = 0;
				var cury = 0;
				for (var i = 0; i < this.pointidx; lastx = curx, lasty = cury, i++) {
					curx = this.pointx[i];
					cury = this.pointy[i];
					if (cury == lasty) {
						continue;
					}
					var leftx = 0;
					if (curx < lastx) {
						if (x >= lastx) {
							continue;
						}
						leftx = curx;
					} else {
						if (x >= curx) {
							continue;
						}
						leftx = lastx;
					}
					var temp1 = 0;
					var temp2 = 0;
					if (cury < lasty) {
						if (y < cury || y >= lasty) {
							continue;
						}
						if (x < leftx) {
							hits++;
							continue;
						}
						temp1 = x - curx;
						temp2 = y - cury;
					} else {
						if (y < lasty || y >= cury) {
							continue;
						}
						if (x < leftx) {
							hits++;
							continue;
						}
						temp1 = x - lastx;
						temp2 = y - lasty;
					}
					if (temp1 < (temp2 / (lasty - cury) * (lastx - curx))) {
						hits++;
					}
				}
				return ((hits & 1) != 0);
			};
		}

		function base64Decode(str){
			return atob(str);
		}

		function stringToUtf8ByteArray(str) {
			// TODO(user): Use native implementations if/when available
			var out = [], p = 0;
			for (var i = 0; i < str.length; i++) {
				var c = str.charCodeAt(i);
				if (c < 128) {
					out[p++] = c;
				} else if (c < 2048) {
					out[p++] = (c >> 6) | 192;
					out[p++] = (c & 63) | 128;
				} else if (
						((c & 0xFC00) == 0xD800) && (i + 1) < str.length &&
						((str.charCodeAt(i + 1) & 0xFC00) == 0xDC00)) {
					// Surrogate Pair
					c = 0x10000 + ((c & 0x03FF) << 10) + (str.charCodeAt(++i) & 0x03FF);
					out[p++] = (c >> 18) | 240;
					out[p++] = ((c >> 12) & 63) | 128;
					out[p++] = ((c >> 6) & 63) | 128;
					out[p++] = (c & 63) | 128;
				} else {
					out[p++] = (c >> 12) | 224;
					out[p++] = ((c >> 6) & 63) | 128;
					out[p++] = (c & 63) | 128;
				}
			}
			return out;
		};

		function utf8ByteArrayToString (bytes) {
			// TODO(user): Use native implementations if/when available
			var out = [], pos = 0, c = 0;
			while (pos < bytes.length) {
				var c1 = bytes[pos++];
				if (c1 < 128) {
					out[c++] = String.fromCharCode(c1);
				} else if (c1 > 191 && c1 < 224) {
					var c2 = bytes[pos++];
					out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
				} else if (c1 > 239 && c1 < 365) {
					// Surrogate Pair
					var c2 = bytes[pos++];
					var c3 = bytes[pos++];
					var c4 = bytes[pos++];
					var u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) -
							0x10000;
					out[c++] = String.fromCharCode(0xD800 + (u >> 10));
					out[c++] = String.fromCharCode(0xDC00 + (u & 1023));
				} else {
					var c2 = bytes[pos++];
					var c3 = bytes[pos++];
					out[c++] =
							String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
				}
			}
			return out.join('');
		};

		function hexToBytes(hex) {    for (var bytes = [], c = 0; c < hex.length; c += 2)    bytes.push(parseInt(hex.substr(c, 2), 16));    return bytes;}
		function bytesToHex(bytes) {    for (var hex = [], i = 0; i < bytes.length; i++) {        hex.push((bytes[i] >>> 4).toString(16));        hex.push((bytes[i] & 0xF).toString(16));    }    return hex.join("");}


		this.createSecureKeyboard = function(keyboardType, callback, tobefocusedId) {
			var current = this;

			MLServlet.getSecureKeyboard(ML4WebVKeyPad.mChallenge, "qwerty,number", "table", 11, 33, function(oSecureTable){
				var secureToken = "";

				current.mKeyboard = new Array();

				if (oSecureTable.code != 0) {
					callback(oSecureTable);
					return;
				}

				if (typeof(oSecureTable.token) != "undefined") {
					secureToken          = oSecureTable.token;
					ML4WebVKeyPad.mToken = oSecureTable.token;
				}

				var script  = magicjs.hex.decode(oSecureTable.message);
				// script = script.replace(/VKT/g, "VKT");
				script = script.replace(/VKT/g, VKT.name);
				var returns = "return [qwerty,number];";
				var res     = (new Function(VKT+script+returns))();

				for (var i=0; i<current.mKeyboardLayouts.length; i++){
					current.mKeyboard[current.mKeyboardLayouts[i]] = res[i];
				}

				if (MLVKeyUtils.isAccessiblity() == false && MLVKeyUtils.isMobileDevice() == false) {
					if (keyboardType == "qwerty") {
						MLServlet.getSecureKeyboard(ML4WebVKeyPad.mChallenge, "qwerty", "normal$shift", 11, 33, callbackSecureImage, secureToken);
					} else if (keyboardType == "number") {
						MLServlet.getSecureKeyboard(ML4WebVKeyPad.mChallenge, "number", "normal", 11, 33, callbackSecureImage, secureToken);
					}
				} else {
					if (keyboardType == "qwerty") {
						MLServlet.getSecureKeyboard(ML4WebVKeyPad.mChallenge, "qwertyMobile", "normal$shift$other", 11, 33, callbackSecureImage, secureToken);
					} else if (keyboardType == "number") {
						MLServlet.getSecureKeyboard(ML4WebVKeyPad.mChallenge, "numberMobile", "common", 11, 33, callbackSecureImage, secureToken);
					}
				}

				function callbackSecureImage(secureImage) {
					if (typeof(secureImage.code) == "undefined" || secureImage.code != 0) {
						throw {code: MLVKeyErrCode.AXERR_PARSEMSG_FAIL.code, message: MLVKeyErrCode.AXERR_PARSEMSG_FAIL.message + "magicVKeyPadObject.createSecureKeyboard.1"};
					}

					if (typeof(secureImage.token) != "undefined") {
						ML4WebVKeyPad.mToken = secureImage.token;
					}

					if (MLVKeyUtils.isAccessiblity() == false && MLVKeyUtils.isMobileDevice() == false) {
						if (typeof(secureImage.message.normal) != "undefined") {
							current.layoutLowerDiv.style.backgroundImage = String.format('url({0})', secureImage.message.normal);
						}
						if (typeof(secureImage.message.shift) != "undefined") {
							current.layoutUpperDiv.style.backgroundImage = String.format('url({0})', secureImage.message.shift);
						}
					} else {
						// 241213
						// 웹접근성 keydown 이벤트 제한 - 닫기버튼
						function validateKeyCodeWithClose(e){
							let key = (e.code === 'Space') ? e.code : (e.keyCode || e.key || e.code);
							if ((key     === 'Space'     || key === 32)
									|| (key  === 'Enter'     || key === 13)
									|| (key  === 'Tab'       || key === 9)
									|| ((key === 'Tab' && e.shiftKey) || (key === 9 && key === 16))) {
								ML4WebVKey.now.closeButton();
							} else {
								e.preventDefault();
							}
						}

						// 241212
						// 웹접근성 keydown 이벤트 제한
						function validateKeyCodeWithStart(e, i) {
							let key = (e.code === 'Space') ? e.code : (e.keyCode || e.key || e.code);
							if ((key     === 'Space'     || key === 32)
									|| (key  === 'Enter'     || key === 13)
									|| (key  === 'Tab'       || key === 9)
									|| ((key === 'Tab' && e.shiftKey) || (key === 9 && key === 16))) {
								ML4WebVKey.now.start(e, i, false);
							} else {
								e.preventDefault();
							}
						}


						// 241127
						// Setting the element ID to be focused

						if (typeof (tobefocusedId) == "string" && tobefocusedId !== "") {
							current.hiddenField.dataset.tobefocused = tobefocusedId;
						}
						if (keyboardType == "qwerty") {
							var keycount = secureImage.message.count;
							var index=0;
							var firstLowerDiv	 = current.layoutLowerDiv.children[0];
							var lastLowerDiv	 = current.layoutLowerDiv.children[keycount + 1];
							var firstUpperDiv	 = current.layoutUpperDiv.children[0];
							var lastUpperDiv	 = current.layoutUpperDiv.children[keycount + 1];
							var firstOtherDiv	 = current.layoutOtherDiv.children[0];
							var lastOtherDiv	 = current.layoutOtherDiv.children[keycount + 1];

							// TODO 문법수정
							function modalTrapFocus(event) {
								if (event.keyCode === 9) {
									if ( !event.shiftKey && document.activeElement === lastLowerDiv) {
										firstLowerDiv.focus();
										event.preventDefault();
									} else if ( event.shiftKey && document.activeElement === firstLowerDiv) {
										lastLowerDiv.focus();
										event.preventDefault();
									} else if ( !event.shiftKey && document.activeElement === lastUpperDiv) {
										firstUpperDiv.focus();
										event.preventDefault();
									} else if ( event.shiftKey && document.activeElement === firstUpperDiv) {
										lastUpperDiv.focus();
										event.preventDefault();
									}else if ( !event.shiftKey && document.activeElement === lastOtherDiv) {
										firstOtherDiv.focus();
										event.preventDefault();
									} else if ( event.shiftKey && document.activeElement === firstOtherDiv) {
										lastOtherDiv.focus();
										event.preventDefault();
									}
								}
							}

							current.layoutDiv.addEventListener("keydown", modalTrapFocus);

							for ( index=0; index<=keycount; index++) {
								var sNumber  = MLVKeyUtils.getPadDigits(index, 2);
								var oMessage = secureImage.message[sNumber];

								current.layoutLowerDiv.children[index].style.backgroundImage = String.format('url({0})', oMessage.lower.image);
								current.layoutLowerDiv.children[index].style.backgroundColor = "#FFFFFF";
								current.layoutLowerDiv.children[index].setAttribute("keyname", oMessage.lower.keyname);
								current.layoutLowerDiv.children[index].onmousedown = function(event) {
									ML4WebVKey.now.start(event,index,false);
								}

								current.layoutUpperDiv.children[index].style.backgroundImage = String.format('url({0})', oMessage.upper.image);
								current.layoutUpperDiv.children[index].style.backgroundColor = "#FFFFFF";
								current.layoutUpperDiv.children[index].setAttribute("keyname", oMessage.upper.keyname);
								current.layoutUpperDiv.children[index].onmousedown = function(event) {
									ML4WebVKey.now.start(event,index,false);
								}

								current.layoutOtherDiv.children[index].style.backgroundImage = String.format('url({0})', oMessage.other.image);
								current.layoutOtherDiv.children[index].style.backgroundColor = "#FFFFFF";
								current.layoutOtherDiv.children[index].setAttribute("keyname", oMessage.other.keyname);
								current.layoutOtherDiv.children[index].onmousedown = function(event) {
									ML4WebVKey.now.start(event,index,false);
								}

								if (MLVKeyUtils.isAccessiblity() || MLVKeyUtils.isMobileDevice()){
									current.layoutLowerDiv.children[index].setAttribute("tabindex", keycount*20000+index+1);
									current.layoutLowerDiv.children[index].setAttribute("role","button");
									current.layoutLowerDiv.children[index].setAttribute("aria-label", oMessage.lower.label);
									current.layoutLowerDiv.children[index].onkeypress = function(event) {
										validateKeyCodeWithStart(event, index);
									}

									current.layoutUpperDiv.children[index].setAttribute("tabindex", keycount*20000+index+101);
									current.layoutUpperDiv.children[index].setAttribute("role","button");
									current.layoutUpperDiv.children[index].setAttribute("aria-label", oMessage.upper.label);
									current.layoutUpperDiv.children[index].onkeypress = function(event) {
										validateKeyCodeWithStart(event, index);
									}

									current.layoutOtherDiv.children[index].setAttribute("tabindex", keycount*20000+index+201);
									current.layoutOtherDiv.children[index].setAttribute("role","button");
									current.layoutOtherDiv.children[index].setAttribute("aria-label", oMessage.other.label);
									current.layoutOtherDiv.children[index].onkeypress = function(event) {
										validateKeyCodeWithStart(event, index);
									}
									if( index == 33){
										// shift 버튼
										current.layoutLowerDiv.children[index].onkeyup = function(e) {
											if(e.keyCode == 13 || e.keyCode==32){
												var id = e.target.id;
												var tid = id.replace(/lower/i, 'Upper');
												var target = document.getElementById(tid.substr(0,tid.indexOf("Div")+3)+1);
												target.focus();
											}
										}
										current.layoutUpperDiv.children[index].onkeyup = function(e) {
											if(e.keyCode == 13 || e.keyCode==32){
												var id = e.target.id;
												var tid = id.replace(/upper/i, 'Lower');
												var target = document.getElementById(tid.substr(0,tid.indexOf("Div")+3)+1);
												target.focus();
											}
										}
										current.layoutOtherDiv.children[index].onkeyup = function(e) {
											if(e.keyCode == 13 || e.keyCode==32){
												var id = document.activeElement.id;
												var tid = id.replace(/other/i, 'Lower');
												var target = document.getElementById(tid.substr(0,tid.indexOf("Div")+3)+1);
												target.focus();
											}
										}


									}else if( index == 44){
										// refresh 버튼
										current.layoutLowerDiv.children[index].onkeyup = function(e) {
											if(e.keyCode == 13 || e.keyCode==32){
												var id = e.target.id;
												var target = document.getElementById(id.substr(0,id.indexOf("Div")+3)+1);

												let timerId = setInterval(() => target.focus(), 100);
												setTimeout(() => { clearInterval(timerId); }, 500);
											}
										}
										current.layoutUpperDiv.children[index].onkeyup = function(e) {
											if(e.keyCode == 13 || e.keyCode==32){
												var id = e.target.id;
												var tid = id.replace(/upper/i, 'Lower');
												var target = document.getElementById(tid.substr(0,tid.indexOf("Div")+3)+1);

												let timerId = setInterval(() => target.focus(), 100);
												setTimeout(() => { clearInterval(timerId); }, 500);
											}
										}
										current.layoutOtherDiv.children[index].onkeyup = function(e) {
											if(e.keyCode == 13|| e.keyCode==32){
												var id = e.target.id;
												var tid = id.replace(/other/i, 'Lower');
												var target = document.getElementById(tid.substr(0,tid.indexOf("Div")+3)+1);

												let timerId = setInterval(() => target.focus(), 100);
												setTimeout(() => { clearInterval(timerId); }, 500);
											}
										}
									}else if( index == 46){
										// special 버튼
										current.layoutLowerDiv.children[index].onkeyup = function(e) {
											if(e.keyCode == 13 || e.keyCode==32){
												var id = e.target.id;
												var tid = id.replace(/lower/i, "Other");

												var target = document.getElementById(tid.substr(0,tid.indexOf("Div")+3)+1);
												target.focus();
											}
										}
										current.layoutUpperDiv.children[index].onkeyup = function(e) {
											if(e.keyCode == 13|| e.keyCode==32){
												var id = e.target.id;
												var tid = id.replace(/upper/i, "Other");
												var target = document.getElementById(tid.substr(0,tid.indexOf("Div")+3)+1);
												target.focus();
											}
										}
										current.layoutOtherDiv.children[index].onkeyup = function(e) {
											if(e.keyCode == 13|| e.keyCode==32){
												var id = e.target.id;
												var tid = id.replace(/other/i, "Lower");
												var target = document.getElementById(tid.substr(0,tid.indexOf("Div")+3)+1);
												target.focus();
											}
										}
									}

								}
							}

							current.layoutLowerDiv.children[keycount+1].style.backgroundColor = "#FFFFFF";
							current.layoutLowerDiv.children[keycount+1].onmousedown = function(e) {
								ML4WebVKey.now.closeButton();
							}

							current.layoutUpperDiv.children[keycount+1].style.backgroundColor = "#FFFFFF";
							current.layoutUpperDiv.children[keycount+1].onmousedown = function(event) {
								ML4WebVKey.now.closeButton();
							}


							current.layoutOtherDiv.children[keycount+1].style.backgroundColor = "#FFFFFF";
							current.layoutOtherDiv.children[keycount+1].onmousedown = function(event) {
								ML4WebVKey.now.closeButton();
							}



							if (MLVKeyUtils.isMobileDevice() || MLVKeyUtils.isAccessiblity()){
								if(MLVKeyUtils.isMobileDevice() == false){
									current.layoutLowerDiv.children[keycount+1].className = "mobile_qwerty_layoutClassDiv_bd_none";
									current.layoutUpperDiv.children[keycount+1].className = "mobile_qwerty_layoutClassDiv_bd_none";
									current.layoutOtherDiv.children[keycount+1].className = "mobile_qwerty_layoutClassDiv_bd_none";
								}

								current.layoutLowerDiv.children[keycount+1].style.backgroundImage = String.format('url({0})', secureImage.message.close.image);
								current.layoutUpperDiv.children[keycount+1].style.backgroundImage = String.format('url({0})', secureImage.message.close.image);
								current.layoutOtherDiv.children[keycount+1].style.backgroundImage = String.format('url({0})', secureImage.message.close.image);

								current.layoutLowerDiv.setAttribute("tabindex", keycount*20000);
								current.layoutLowerDiv.setAttribute("role","group");
								current.layoutLowerDiv.setAttribute("aria-label", "소문자 키보드");


								current.layoutLowerDiv.children[keycount+1].setAttribute("tabindex", keycount*20000+index+1);
								current.layoutLowerDiv.children[keycount+1].setAttribute("role","button");
								current.layoutLowerDiv.children[keycount+1].setAttribute("aria-label", "닫기");
								current.layoutLowerDiv.children[keycount+1].onkeypress = function(e) {
									validateKeyCodeWithClose(e);
								}

								current.layoutUpperDiv.setAttribute("tabindex", keycount*20000+100);
								current.layoutUpperDiv.setAttribute("role","group");
								current.layoutUpperDiv.setAttribute("aria-label", "대문자 키보드");


								current.layoutUpperDiv.children[keycount+1].setAttribute("tabindex", keycount*20000+index+100);
								current.layoutUpperDiv.children[keycount+1].setAttribute("role","button");
								current.layoutUpperDiv.children[keycount+1].setAttribute("aria-label", "닫기");
								current.layoutUpperDiv.children[keycount+1].onkeypress = function(event) {
									validateKeyCodeWithClose(event);
								}

								current.layoutOtherDiv.setAttribute("tabindex", keycount*20000+200);
								current.layoutOtherDiv.setAttribute("role","group");
								current.layoutOtherDiv.setAttribute("aria-label", "특수문자 키보드");


								current.layoutOtherDiv.children[keycount+1].setAttribute("tabindex", keycount*20000+index+200);
								current.layoutOtherDiv.children[keycount+1].setAttribute("role","button");
								current.layoutOtherDiv.children[keycount+1].setAttribute("aria-label", "닫기");

								current.layoutOtherDiv.children[keycount+1].onkeypress = function(event) {
									validateKeyCodeWithClose(event);
								}
							}else{
								current.layoutLowerDiv.children[keycount+1].style.backgroundImage = String.format('url({0})', secureImage.message.close.image);
								current.layoutUpperDiv.children[keycount+1].style.backgroundImage = String.format('url({0})', secureImage.message.close.image);
								current.layoutOtherDiv.children[keycount+1].style.backgroundImage = String.format('url({0})', secureImage.message.close.image);
							}

						} else if (keyboardType == "number") {
							var keycount = secureImage.message.count;
							var index=0;

							//241216
							//닫기버튼 이벤트 추가
							let firstLowerDiv	 = current.layoutLowerDiv.children[0];
							let lastLowerDiv	 = current.layoutLowerDiv.children[keycount + 1];
							let enterDiv = current.layoutLowerDiv.children[keycount];

							// TODO 문법수정
							let modalTrapFocus = (event) => {
								if (event.keyCode === 9) {
									if ( !event.shiftKey && document.activeElement === lastLowerDiv) {
										firstLowerDiv.focus();
										event.preventDefault();
									} else if ( event.shiftKey && document.activeElement === current.layoutLowerDiv) {
										enterDiv.focus();
										event.preventDefault();
									} else if ( event.shiftKey && document.activeElement === lastLowerDiv) {
										lastLowerDiv.focus();
										event.preventDefault();
									}
								}
							}
							current.layoutDiv.addEventListener("keydown", modalTrapFocus);

							for ( index=0;index<=keycount; index++) {
								var sNumber  = MLVKeyUtils.getPadDigits(index, 2);
								var oMessage = secureImage.message[sNumber];

								current.layoutLowerDiv.children[index].style.backgroundImage = String.format('url({0})', oMessage.lower.image);
								current.layoutLowerDiv.children[index].style.backgroundColor = "#FFFFFF";
								current.layoutLowerDiv.children[index].setAttribute("keyname", oMessage.lower.keyname);

								current.layoutLowerDiv.children[index].onmousedown = function(event) {
									ML4WebVKey.now.start(event,index,false);
								}

								if (MLVKeyUtils.isMobileDevice() || MLVKeyUtils.isAccessiblity()){

									if( index == 0 ){
										current.layoutLowerDiv.children[index].onkeydown = function(e) {
											if(e.keyCode == 9 && e.shiftKey){
												var id = document.activeElement.id;

												var target = document.getElementById(id.substr(0,id.indexOf("Div")+3)+16);
												target.focus();
											}
										}
									}else if ( index == keycount){
										current.layoutLowerDiv.children[keycount+1].onkeydown = function(e) {
											if(e.keyCode == 9){
												var id = document.activeElement.id;
												var target = document.getElementById(id.substr(0,id.indexOf("Div")+3));
												target.focus();
											}
										}
									}
									current.layoutLowerDiv.children[index].setAttribute("tabindex", keycount*10000+index+1);
									current.layoutLowerDiv.children[index].setAttribute("role","button");
									current.layoutLowerDiv.children[index].setAttribute("aria-label", oMessage.lower.label);
									current.layoutLowerDiv.children[index].onkeypress = function(event) {
										validateKeyCodeWithStart(event, index);
									}
								}

								current.layoutLowerDiv.setAttribute("tabindex", keycount*10000);
								current.layoutLowerDiv.setAttribute("role","group");
								current.layoutLowerDiv.setAttribute("aria-label", "숫자 키보드");

							}

							// 241214
							// onKeypress close btn
							if(current.layoutLowerDiv.children[keycount+1]!=null){
								current.layoutLowerDiv.children[keycount+1].style.backgroundColor = "#FFFFFF";
								current.layoutLowerDiv.children[keycount+1].onmousedown = function(event) {
									// console.log('keycount', keycount+1);
									// // 클릭 X
									// // 닫기버튼
									// let args = {
									// 	"onmousedown": true,
									// 	"useFocusTag": true,
									// };
									// ML4WebVKey.now.closeButton(args);
									ML4WebVKey.now.closeButton();
								}

								if (MLVKeyUtils.isMobileDevice() || MLVKeyUtils.isAccessiblity()){
									current.layoutLowerDiv.children[keycount+1].setAttribute("tabindex", keycount*10000+index+1);
									current.layoutLowerDiv.children[keycount+1].setAttribute("role","button");
									current.layoutLowerDiv.children[keycount+1].setAttribute("aria-label", "닫기");
									current.layoutLowerDiv.children[keycount+1].onkeypress = function(e) {
										validateKeyCodeWithClose(e);
									}

									if(MLVKeyUtils.isMobileDevice() == false){
										current.layoutLowerDiv.children[keycount+1].className = "mobile_qwerty_layoutClassDiv_bd_none";
									}
									current.layoutLowerDiv.children[keycount+1].style.backgroundImage = String.format('url({0})', secureImage.message.close.image);
								}else{
									current.layoutLowerDiv.children[keycount+1].style.backgroundImage = String.format('url({0})', secureImage.message.close.image);
								}
							}
						}
					}

					if (keyboardType == "qwerty") {
						current.setKeyType("lower");
					} else {
						current.setKeyType("number");
					}

					current.showKeyboardLayout();
					current.setMultiCursor(false);

					if (typeof(callback) == "function") {
						callback(0);
					}
				}
			}, ML4WebVKeyPad.mToken);
		}

		this.setButton = function(inputObject, useButton) {
			if (useButton == false || useButton == "false") {
				return;
			}

			try {
				var button       = document.createElement("button");
				var button_size  = 25;
				var button_xy	 = [0,0];
				var button_index = -1;

				if (inputObject.getAttribute("ds-kb-button") != null) {
					button_size = inputObject.getAttribute("ds-kb-button");

					if (inputObject.getAttribute("ds-kb-button-xy") != null) {
						button_xy = JSON.parse(inputObject.getAttribute("ds-kb-button-xy"));
						button_xy.length != 2 ? button_xy = JSON.parse("[0,0]") : 0;
					}

					if (inputObject.getAttribute("ds-kb-button-index") != null) {
						button_index = inputObject.getAttribute("ds-kb-button-index");
					}
				}

				button.setAttribute("id", inputObject.id + "_magicButton");
				button.setAttribute("tabindex", button_index);
				button.setAttribute("style", String.format('display:none; position: absolute; top: 0px; left: 0px; width: {0}px; height: {1}px; background: url({2}) no-repeat; border: none; z-index:5000009;', ML4WebVKeyPad.mCommonImage.input_size[0], ML4WebVKeyPad.mCommonImage.input_size[1], ML4WebVKeyPad.mCommonImage.input));

				try {
					var clientRect  = document.getElementById(inputObject.id).getBoundingClientRect();
					var clientStyle = button.style;

					clientStyle.setProperty("display", "block");
					clientStyle.setProperty("left", clientRect.right + button_xy[0] + "px");
					clientStyle.setProperty("top",  clientRect.top   + window.pageYOffset + button_xy[1] + "px");
				} catch (ex) {
					clientStyle.setAttribute("display", "block");
					clientStyle.setAttribute("left", clientRect.right + button_xy[0] + "px");
					clientStyle.setAttribute("top",  clientRect.top   + window.pageYOffset + button_xy[1] + "px");
				}

				if (button.addEventListener ) {
					button.addEventListener("click", ML4WebVKey.buttonclick, false);
				} else{
					button.attachEvent("onclick", ML4WebVKey.buttonclick);
				}

				MLVKeyUtils.insertAfter(inputObject, button);
			} catch (ex) {

			}
		}

		this.setKeyType = function(keyType) {
			this.mKeyType = keyType;
			this.mKeyFlag = keyType.charAt(0);

			if (keyType == "lower") {
				this.mCapsLock = false;
			} else if (keyType == "upper") {
				this.mCapsLock = true;
			}
		}

		this.setKeyboardLayout = function(obj) {
			if (obj == null || typeof(obj) == "undefined") {
				return;
			}

			ML4WebVKey.now = this;

			if ((obj.getAttribute("ds-kb-type") != null)) {
				this.mKeyboardPosition = [0,0];

				if (obj.getAttribute("ds-kb-xy") != null) {
					this.mKeyboardPosition = JSON.parse(obj.getAttribute("ds-kb-xy"));
					this.mKeyboardPosition.length != 2 ? this.mKeyboardPosition = JSON.parse("[0,0]") : 0;
				}

				if (obj.getAttribute("ds-kb-type") == "qwerty") {
					this.mKeyboardPosition.push(550);
					this.mKeyboardPosition.push(8);
				} else if (obj.getAttribute("ds-kb-type") == "number") {
					this.mKeyboardPosition.push(190);
					this.mKeyboardPosition.push(8);
				}

				try {
					var elementId    = obj.id + "_layout";
					var clientRect   = document.getElementById(obj.id).getBoundingClientRect();
					var clientStyle  = document.getElementById(elementId).style;

					this.mKeyboardPosition.push(clientRect.left);
					this.mKeyboardPosition.push(clientRect.bottom);

					if (MLVKeyUtils.isAccessiblity() == false && MLVKeyUtils.isMobileDevice() == false) {
						this.divs[0].style.setProperty("left", clientRect.left + this.mKeyboardPosition[0] + "px");
						this.divs[0].style.setProperty("top",  clientRect.top  + window.pageYOffset + clientRect.height + this.mKeyboardPosition[1] + "px");

						this.divs[1].style.setProperty("left", clientRect.left + this.mKeyboardPosition[0] + "px");
						this.divs[1].style.setProperty("top",  clientRect.top  + window.pageYOffset + clientRect.height + this.mKeyboardPosition[1] + "px");

						this.divs[2].style.setProperty("left", clientRect.left + this.mKeyboardPosition[0] + "px");
						this.divs[2].style.setProperty("top",  clientRect.top  + window.pageYOffset + clientRect.height + this.mKeyboardPosition[1] + "px");

						if (this.mMultiCursor) {
							this.divs[3].style.setProperty("left", clientRect.left + this.mKeyboardPosition[0] + 251 + "px");
							this.divs[3].style.setProperty("top",  clientRect.top  + window.pageYOffset + clientRect.height + this.mKeyboardPosition[1] + 7 + "px");

							this.divs[4].style.setProperty("left", clientRect.left + this.mKeyboardPosition[0] + 251 + "px");
							this.divs[4].style.setProperty("top",  clientRect.top  + window.pageYOffset + clientRect.height + this.mKeyboardPosition[1] + 7 + "px");
						}

						this.divs[5].style.setProperty("left", clientRect.left + this.mKeyboardPosition[0] + this.mKeyboardPosition[2] + "px");
						this.divs[5].style.setProperty("top",  clientRect.top  + + window.pageYOffset + clientRect.height + this.mKeyboardPosition[1] + this.mKeyboardPosition[3] + "px");
					} else if (MLVKeyUtils.isAccessiblity() == true && MLVKeyUtils.isMobileDevice() == false) {
						this.layoutDiv.style.position = "relative";

						this.layoutDiv.parentElement.style.position ='absolute';
						this.layoutDiv.parentElement.style.setProperty("left", clientRect.left + this.mKeyboardPosition[0] + "px");
						this.layoutDiv.parentElement.style.setProperty("top",  clientRect.top  + window.pageYOffset + clientRect.height + this.mKeyboardPosition[1] + "px");

						this.layoutDiv.parentElement.style.setProperty("padding","0px 10px 10px");
						this.layoutDiv.parentElement.style.setProperty("background","white");
						this.layoutDiv.parentElement.style.setProperty("border","1px solid #5B5B5B");
						this.layoutDiv.parentElement.style.setProperty("border-radius","6px");
						this.layoutDiv.parentElement.style.setProperty("box-shadow","0 0 10px rgba(0,0,0,0.3)");
						this.layoutDiv.parentElement.style.setProperty("backdrop-filter","blur(5px)");
						this.layoutDiv.parentElement.style.setProperty("z-index","2147483647");
//            			this.layoutDiv.parentElement.classList.add('accessibility');

					}else {
						var scrollLocation = document.documentElement.scrollTop;// 현재 스크롤바 위치
						var windowHeight   = window.innerHeight;				// 스크린 창
						var fullHeight     = document.body.scrollHeight;		// margin 값은 포함 x
						var startPositionY = scrollLocation + (windowHeight-parseInt(this.mainDiv.style.height));

						this.layoutDiv.style.setProperty("top",  startPositionY-10 + "px");
					}
					clientStyle.setProperty("display", "block");
					clientStyle.setProperty("visibility","visible");

					// 장애인 접근성, mobile 일때만 해당 - 첫번째 Element Focus
					if ( MLVKeyUtils.isMobileDevice() == true || MLVKeyUtils.isAccessiblity() == true) {
						var firstTarget = document.getElementById(obj.id + "_layoutLowerDiv1");
						firstTarget.style.setProperty("z-index","2147483647");
						firstTarget.style.setProperty("border","2px solid black");
						firstTarget.style.setProperty("border-radius","4px");
						firstTarget.addEventListener('focusout', (event)=>{
							event.target.style.setProperty("border","0px");
							event.target.style.setProperty("z-index","");
						});

						firstTarget.focus();
					}

				} catch (ex) { }
			}
		}

		this.showKeyboard = function(callback, tobefocusedId) {
			try {
				var current = this;

				current.inputField.readOnly = true;

				current.clearKey();

				current.createSecureKeyboard(current.mKeyboardType, function(code){
					if(code==0){
						current.setKeyboardLayout(current.inputField);
						if(callback!=null)
							callback();

						MLStatusCode = 2;
					}else{
						console.log("fail to create SecureKeyboard :"+JSON.stringify(code.message));
						MLStatusCode = -2;

						var inputFieldId = current.inputField.id;

						ML4WebVKeyPad.createSession(function(){
							showKeyboard(inputFieldId, callback, tobefocusedId);
							MLStatusCode = 2;
						});
					}
				}, tobefocusedId);
			} catch (ex) {
				current.inputField.readOnly = false;
				throw ex;
			}
		}

		this.showKeyboardLayout = function() {

			if (typeof(this.layoutDiv.parentElemnt) != "undefined") {
				this.layoutDiv.parentElemnt.style.display = "none";
			}
			if (typeof(this.layoutLowerDiv) != "undefined") {
				this.layoutLowerDiv.style.display = "none";
			}
			if (typeof(this.layoutUpperDiv) != "undefined") {
				this.layoutUpperDiv.style.display = "none";
			}
			if (typeof(this.layoutOtherDiv) != "undefined") {
				this.layoutOtherDiv.style.display = "none";
			}

			if (typeof(this.mKeyType) != "undefined" && (this.mKeyType == "lower" || this.mKeyType == "number")) {
				if (typeof(this.layoutLowerDiv) != "undefined") {
					this.layoutLowerDiv.style.display = "block";
				}
			} else if (typeof(this.mKeyType) != "undefined" && this.mKeyType == "upper"){
				if (typeof(this.layoutUpperDiv) != "undefined") {
					this.layoutUpperDiv.style.display = "block";
				}
			}
		}

		this.hideKeyboardLayout = function(args) {

			if (typeof(this.layoutDiv.parentElement) != "undefined") {
				this.layoutDiv.parentElement.style.cssText = "";
			}
			if (typeof(this.layoutDiv.style.display) != "undefined") {
				this.layoutDiv.style.display = "none";
			}
			if (typeof(this.layoutLowerDiv) != "undefined") {
				this.layoutLowerDiv.style.display = "none";
			}
			if (typeof(this.layoutUpperDiv) != "undefined") {
				this.layoutUpperDiv.style.display = "none";
			}
			if (typeof(this.layoutOtherDiv) != "undefined") {
				this.layoutOtherDiv.style.display = "none";
			}

			this.inputField.readOnly = false;

			// 250423
			// vKeypad 닫히고서, 포커스가 vKeypad 설정값으로 이동하지 않도록 수정
			if (args?.onmousedown && !(args.useFocusTag) ) return;

			// 241127
			// Setting the element to be focused
			let tobefocusedId = document.getElementById(this.hiddenField.id).getAttribute("data-tobefocused");

			if (tobefocusedId && typeof (tobefocusedId) === "string") {
				//showKeyboard api
				let actualHiddenField = document.getElementById(this.hiddenField.id);
				let tobefocusedElem = document.getElementById(actualHiddenField.dataset.tobefocused);
				tobefocusedElem.focus();
			}
			else {
				// input tag api
				let focustagId = this.inputField.getAttribute("ds-kb-focustag");
				if (focustagId && typeof (focustagId) === "string") {
					document.getElementById(focustagId).focus();
				}
			}
		}

		this.start = function(event, index, realDiv) {
			var checkDiv = false;

			if (realDiv != null && typeof(realDiv) != "undefined") {
				checkDiv = realDiv;
			}

			var delimiter = '#';
			var keyType   = "";
			var secureX   = 0;
			var secureY   = 0;
			var secureKey = null;
			var secureKeyName = "";
			var focusTarget ;

			if (event.offsetX != null || event.offsetY != null) {
				secureX = event.offsetX;
				secureY = event.offsetY;
			} else if (event.layerX != null || event.layerY != null) {
				secureX = event.layerX;
				secureY = event.layerY;
			}

			secureX = parseInt(secureX);
			secureY = parseInt(secureY);

			if (MLVKeyUtils.isAccessiblity() == false && MLVKeyUtils.isMobileDevice() == false) {
				keyType   = this.mKeyFlag;
				secureKey = this.getSecureKey(secureX, secureY, this.mKeyboardType);
			} else {
				keyType   = "m";
				secureKey = new Object();
				secureKey.keyname = event.target.getAttribute("keyname");
			}

			if (secureKey != null) {
				secureKeyName = secureKey.keyname;

				if (secureKey.keyname == "backspace") {
					if (MLVKeyUtils.isAccessiblity() == false && MLVKeyUtils.isMobileDevice() == false && MLVKeyConfig.isKeyPress) {
						var div = document.getElementById(this.inputField.id + "_press_key");
						this.keyPress(div, secureKey);
					} else if (MLVKeyConfig.isKeyPress) {
						this.keyPress(event.target, secureKey);
					}
					this.deleteKey();
				} else if (secureKey.keyname == "clear") {
					if (MLVKeyUtils.isAccessiblity() == false && MLVKeyUtils.isMobileDevice() == false && MLVKeyConfig.isKeyPress) {
						var div = document.getElementById(this.inputField.id + "_press_key");
						this.keyPress(div, secureKey);
					} else if (MLVKeyConfig.isKeyPress) {
						this.keyPress(event.target, secureKey);
					}
					this.clearKey();
				} else if (secureKey.keyname == "shift") {
					this.shiftKey();
					if (this.mCapsLock == false) {
						if(document.getElementById(this.inputField.id+"_layoutLowerDiv")!='undefined')
							focusTarget = document.getElementById(this.inputField.id+"_layoutLowerDiv1");
					}else{
						if(document.getElementById(this.inputField.id+"_layoutUpperDiv")!='undefined')
							focusTarget =document.getElementById(this.inputField.id+"_layoutUpperDiv1");
					}
				} else if (secureKey.keyname == "special") {
					this.otherKey();

					if(this.layoutOtherDiv.style.display == "block"){
						if(document.getElementById(this.inputField.id+"_layoutOtherDiv")!='undefined')
							focusTarget = document.getElementById(this.inputField.id+"_layoutOtherDiv1");
					}else{
						if(document.getElementById(this.inputField.id+"_layoutLowerDiv")!='undefined')
							focusTarget = document.getElementById(this.inputField.id+"_layoutLowerDiv1");
					}

				}  else if (secureKey.keyname == "refresh") {
					if (MLVKeyUtils.isAccessiblity() == false && MLVKeyUtils.isMobileDevice() == false && MLVKeyConfig.isKeyPress) {
						var div = document.getElementById(this.inputField.id + "_press_key");
						this.keyPress(div, secureKey);
					} else if (MLVKeyConfig.isKeyPress) {
						this.keyPress(event.target, secureKey);
					}
					this.refreshKey();
				} else if (secureKey.keyname == "enter") {
					this.enterKey();
				} else if (secureKey.keyname != "") {
					secureKeyName = "";

					if (MLVKeyUtils.isAccessiblity() == false && MLVKeyUtils.isMobileDevice() == false && MLVKeyConfig.isKeyPress) {
						var div;

						if (secureKey.pointx[0]==251 && secureKey.pointy[0]==193) {
							div = document.getElementById(this.inputField.id + "_press_space");
						} else {
							div = document.getElementById(this.inputField.id + "_press_key");
						}

						this.keyPress(div, secureKey);
					} else if (MLVKeyConfig.isKeyPress) {
						this.keyPress(event.target, secureKey);
					}

					if( limitOver &&  ((limitOverCount < 0) || (limitOverCount > this.inputField.value.length))){
						this.inputField.value  = this.inputField.value + "*";
						this.hiddenField.value += delimiter + keyType + secureKey.keyname;
					}
				}

				if (focusTarget == undefined) {
					//
				} else if (focusTarget.id.indexOf(this.inputField.id) > -1 && focusTarget.id.indexOf("_layout") > -1) {
					focusTarget.focus();
				}

				if ((this.inputField.getAttribute("ds-kb-keypress") != null)) {
					var reqEncrypt = MLJSCrypto.Encrypt(ML4WebVKeyPad.mChallenge, this.hiddenField.value, "server");
					this.mEncryptedPassword = reqEncrypt.message;

					var callbackFunc  = this.inputField.getAttribute("ds-kb-keypress");
					var callbackName  = callbackFunc.split('(');
					var callbackParam = String.format('{0}(["{1}","{2}","{3}"])', callbackName[0], this.inputField.id, this.inputField.value, secureKeyName);
					var callback      = (new Function(callbackParam))();
				}
			}
		}

		this.getSecureKey = function(x, y, type) {
			var secureKey = this.mKeyboard[type];

			for ( var i = 0; i < secureKey.length; i++) {
				if (secureKey[i].contains(x, y)) {
					return secureKey[i];
				}
			}

			return null;
		}

		this.keyPress = function(div, key) {
			if (this.mMultiCursor) {
				return;
			}

			var dsPressedkey = div;

			if (MLVKeyUtils.isAccessiblity() == false && MLVKeyUtils.isMobileDevice() == false && MLVKeyConfig.isKeyPress) {
				div.style.left    = key.pointx[0]+ this.mKeyboardPosition[0] +  this.mKeyboardPosition[4] + "px";
				div.style.top     = key.pointy[0]+ this.mKeyboardPosition[1] +  this.mKeyboardPosition[5] + "px";
				div.style.display = "block";

				setTimeout(function(){
					try{
						dsPressedkey.style.display = "none";
					}catch(e){
						dsPressedkey.style.display = "none";
					}
				},100);
			} else if (MLVKeyConfig.isKeyPress) {
				div.style.border = String.format('2px solid {0}', MLVKeyConfig.mobileKeyPress);
				div.style.zIndex = 2147483647;
				div.style.setProperty("border-radius","4px");

				setTimeout(function(){
					try{
						dsPressedkey.style.border = "none";
						dsPressedkey.style.zIndex = 0;
					}catch(e){
						dsPressedkey.style.border = "none";
						dsPressedkey.style.zIndex = 0;
					}
				},100);
			}
		}

		this.deleteKey = function() {
			var delimiter = '#';

			this.inputField.value  = this.inputField.value.substring(0, this.inputField.value.length - 1);
			var pos                = this.hiddenField.value.lastIndexOf(delimiter);
			this.hiddenField.value = this.hiddenField.value.substring(0, pos);
		}

		this.clearKey = function() {
			this.inputField.value   = "";
			this.hiddenField.value  = "";
			this.mEncryptedPassword = "";
		}

		this.shiftKey = function() {
			if (this.mCapsLock == false) {
				this.setKeyType("upper");
			} else {
				this.setKeyType("lower");
			}

			this.showKeyboardLayout();
		}

		this.otherKey = function() {
			if (typeof(this.layoutLowerDiv) != "undefined") {
				this.layoutLowerDiv.style.display = "none";
			}
			if (typeof(this.layoutUpperDiv) != "undefined") {
				this.layoutUpperDiv.style.display = "none";
			}
			if (typeof(this.layoutOtherDiv) != "undefined") {
				if (this.layoutOtherDiv.style.display == "none") {
					this.layoutOtherDiv.style.display = "block";
				} else {
					this.layoutOtherDiv.style.display = "none";
					this.setKeyType("lower");
					this.showKeyboardLayout();
				}
			}
		}

		this.refreshKey = function() {
			try {
				var current = this;

				current.clearKey();
				current.createSecureKeyboard(current.mKeyboardType, function(code){
					if(code==0){
						current.setKeyboardLayout(current.inputField);
					}else{
						console.log("fail to create SecureKeyboard :"+code.message);
					}
				});


			} catch (ex) {
				throw ex;
			}
		}

		this.enterKey = function(args) {
			if (this.hiddenField.value.length == 0) {
				this.hideKeyboardLayout(args);	// TODO: 재귀함수 제거
				return;
			}

			try {
				var reqEncrypt = MLJSCrypto.Encrypt(ML4WebVKeyPad.mChallenge, this.hiddenField.value, "server");
				this.mEncryptedPassword = reqEncrypt.message;

				this.hideKeyboardLayout(args);

				if ((arguments.length == 0) && (this.inputField.getAttribute("ds-kb-callback") != null)) {
					var callbackFunc  = this.inputField.getAttribute("ds-kb-callback");
					var callbackName  = callbackFunc.split('(');
					var callbackParam = String.format('{0}("{1}")', callbackName[0], this.inputField.id);
					var callback      = (new Function(callbackParam))();
				}
			} catch (ex) {
				throw ex;
			}
		}

		this.encryptedPassword = function() {
			if (this.mEncryptedPassword == 0 || this.mEncryptedPassword.length == 0) {
				if (this.inputField.value == "" || this.inputField.value.length == 0) {
					return "null";
				} else {
					var reqEncrypt = MLJSCrypto.Encrypt(ML4WebVKeyPad.mChallenge, this.inputField.value, "client");

					if (reqEncrypt.code != 0) {
						return "null";
					} else {
						return reqEncrypt.message;
					}
				}

				return "null";
			}

			return this.mEncryptedPassword;
		}


		this.decryptPassword = function(callback) {
			var result = "";

			if (this.mEncryptedPassword == null || typeof(this.mEncryptedPassword) == "undefined" || this.mEncryptedPassword.length == 0) {
				var returl = this.inputField.value;
				this.inputField.value = "";
				if (typeof(callback) == "function") {
					callback(returl);
					return;
				}
				return result;
			}

			try {
				var current = this;
				if (typeof(callback) == "function") {
					MLServlet.secureRequest(this.mEncryptedPassword, function(resEncrypt){
						if (resEncrypt.code != 0) {
							throw {code:resEncrypt.code, message:resEncrypt.message};
						}

						if (typeof(resEncrypt.token) != "undefined") {
							ML4WebVKeyPad.mToken = resEncrypt.token;
						}

						var resDecrypt = MLJSCrypto.Decrypt(resEncrypt.message);

						if (resDecrypt.code == 0 ) {
							result     = resDecrypt.message;
							resDecrypt = null;
							current.clearKey();
						}

						callback(result);
					}, ML4WebVKeyPad.mToken);
				} else {
					var resEncrypt = MLServlet.secureRequest(this.mEncryptedPassword, null, ML4WebVKeyPad.mToken);

					if (resEncrypt.code != 0) {
						throw {code:resEncrypt.code, message:resEncrypt.message};
					}

					if (typeof(resEncrypt.token) != "undefined") {
						ML4WebVKeyPad.mToken = resEncrypt.token;
					}

					var resDecrypt = MLJSCrypto.Decrypt(resEncrypt.message);

					if (resDecrypt.code == 0 ) {
						result     = resDecrypt.message;
						resDecrypt = null;
						this.clearKey();
					}
				}
			} catch (ex) {
				throw ex;
			}

			return result;
		}

		this.setMultiCursor = function(isVisible) {
			if (isVisible){
				if (typeof(ML4WebVKeyPad.mCommonImage.fake) != "undefined") {
					this.mainDiv.style.setProperty("cursor", String.format('url({0}), auto', ML4WebVKeyPad.mCommonImage.fake));
				}
				//			this.multiMouseTypeDiv.style.display  = "none";
				//			this.singleMouseTypeDiv.style.display = "inline";
				//
				////			if (this.mMultiCursor == true || this.mMultiCursor == "true") {
				////
				////			}
				//
				//			var script = document.createElement('img');
				//			script.setAttribute("id", "vm1");
				//			script.setAttribute("src", ML4WebVKeyPad.mCommonImage.fake);
				//			script.style.setProperty("display", "block");
				//			script.style.setProperty("left", 100 + "px");
				//			script.style.setProperty("top",  100 + "px");
				//
				//
				//			//script.setAttribute("style", String.format('position: fixed; top: 0px; left: 0px; z-index:5000019;'));
				//			MLVKeyUtils.insertAfter(this.mainDiv, script);
			} else {
				this.mainDiv.style.cursor             = 'default';
				//			this.multiMouseTypeDiv.style.display  = "inline";
				//			this.singleMouseTypeDiv.style.display = "none";
				//
				//			var script = document.getElementById("vm1");
				//
				//			if (script != null) {
				//				script.remove();
				//			}
			}
		}

		this.showCursor = function(event, isCursor){
			var x = 0;
			var y = 0;

			if (event.offsetX != null || event.offsetY != null) {
				x = event.offsetX;
				y = event.offsetY;
			} else if (event.layerX != null || event.layerY != null) {
				x = event.layerX;
				y = event.layerY;
			}

			var displayXY = String.format('x = {0}, y = {1}', x, y);

			var vm1top  = -40;
			var vm1left = -40;

			var script = document.getElementById("vm1");

			if (script != null) {
				script.setAttribute("style", String.format('position: fixed; top: {0}px; left: {1}px; z-index:5000019;', y + vm1top, x + vm1left));
			}
		}

		this.hideCursor = function(event) {
			if (this.mMultiCursor == true || this.mMultiCursor == "true") {
				var script = document.getElementById("vm1");

				if (script != null) {
					script.style.display = "none";
				}
			}
		}

		this.visibleCursor = function() {
			if (this.mMultiCursor == true || this.mMultiCursor == "true") {
			}
		}

		this.closeButton = function(args) {
			try {
				// this.enterKey("none");
				console.log('ML4WebVKey.now: ',ML4WebVKey.now);
				this.enterKey(args);
			} catch(ex) {
				console.log(`keyboard close btn exception log:\n${ex}`);
			}
		}
	}

	function magicVKeyPad() {
		this.mChallenge       = "";
		this.mPublicKey       = "";
		this.mCommonImage     = "";
		this.mToken           = "";

		this.setVirtualKeyboard = function(inputObject) {
			try {
				var tmp = document.getElementById(inputObject.id + "_layout");

				if (tmp != null) {
					tmp.parentNode.removeChild(tmp);
				}

				var div0 = document.createElement('div');

				var div = document.createElement('div');

				div.setAttribute("id", inputObject.id + "_layout");
				div.setAttribute("style", "display:none; position: absolute; top: 0px; left: 0px; z-index:5000009;");

				div0.appendChild(div);

				if (inputObject.getAttribute("ds-kb-type") == null) {
					alert("ds-kb-type을 설정해 주세요.(qwerty, number)");
					return;
				}

				var useButton = false;

				if (inputObject.getAttribute("ds-kb-button") != null) {
					useButton = inputObject.getAttribute("ds-kb-button");
				}

				var keyboardType  = inputObject.getAttribute("ds-kb-type");
				var isMultiCursor = MLVKeyConfig.isMultiCursor;

				if (keyboardType == "qwerty") {
					this.setQwertyLayout(inputObject.id, div, isMultiCursor);
				} else if (keyboardType == "number") {
					isMultiCursor = false;
					this.setNumberLayout(inputObject.id, div);
				} else {
					alert("올바른 ds-kb-type을 설정해 주세요.(qwerty, number)");
					return;
				}

				this.setHiddenField(inputObject);

				ML4WebVKey[inputObject.id] = new magicVKeyPadObject(inputObject, div, keyboardType, isMultiCursor);

				ML4WebVKey[inputObject.id].setButton(inputObject, useButton);

				if (keyboardType == "qwerty") {
					ML4WebVKey[inputObject.id].setKeyType("lower");
				} else if (keyboardType == "number") {
					ML4WebVKey[inputObject.id].setKeyType("number");
				}

				ML4WebVKey.objs.push(inputObject.id);
				document.body.appendChild(div.parentElement);
			} catch (ex) {
				throw ex;
			}
		}
		this.createSession = function(callback) {
			try {
				var current   = this;
				var initParam = MLVKeyConfig.isMultiCursor == false ? "p_key$p_space$close$input" : "p_key$p_space$fake$multi_n$multi_p$close$input";

				MLServlet.setSessionKey(MLVKeyConfig.sessionTimeout, initParam, function(oSession){
					if (oSession.code != 0) {
						var exmessage = MLVKeyErrCode.AXERR_MAKESESSIONID_FAIL.message + " => " + oSession.message + "( " + oSession.code + ")";
						callback({code:MLVKeyErrCode.AXERR_MAKESESSIONID_FAIL.code, message: exmessage});
						return;
					}

					current.mChallenge   = oSession.message.challenge;
					current.mPublicKey   = oSession.message.servercert;
					current.mCommonImage = oSession.message.initParam;

					if (typeof(oSession.token) != "undefined") {
						current.mToken = oSession.token;
					}

					var oEnvelop = MLJSCrypto.EnvelopData(current.mChallenge, current.mPublicKey, "dreamsecurity");

					if (oEnvelop.code != 0) {
						callback({code: oEnvelop.code, message: oEnvelop.message});
						return;
					}

					MLServlet.secureRequest(oEnvelop.message, function(oSecureReq){
						if (oSecureReq.code != 0) {
							callback({code: oSecureReq.code, message: oSecureReq.message});
						} else {
							if (typeof(oSecureReq.token) != "undefined") {
								current.mToken = oSecureReq.token;
							}
							callback(oSecureReq);
						}
					}, current.mToken);
				});
			} catch (ex) {
				callback(ex);
			}
		}

		this.setQwertyLayout = function(inputObject, element, isMultiCursor) {
			var divMainEvent = '';
			var divMain = '';
			var layout = ''

			if (MLVKeyUtils.isAccessiblity() == false && MLVKeyUtils.isMobileDevice() == false) {
				divMainEvent = String.format('onmousedown="ML4WebVKey[\'{0}\'].start(event);" onmousemove="ML4WebVKey[\'{1}\'].showCursor(event,false);" onmouseout="ML4WebVKey[\'{2}\'].hideCursor(event);" onmouseover="ML4WebVKey[\'{3}\'].visibleCursor();" oncontextmenu="return false;" ondragstart="return false;" onselectstart="return false;"', inputObject, inputObject, inputObject, inputObject);

				divMain = String.format('<div id="{0}_mainDiv" class="qwerty_mainDiv" {1}></div>', inputObject, divMainEvent);

				layout += String.format('<div id="{0}_layoutLowerDiv" class="qwerty_layoutClass">', inputObject);
				layout += String.format('<iframe id="{0}_block" frameborder="10" style="z-index:-1; position:absolute; visibility: hidden; left: 0px; top: 0px; width: 100%; height: 100%;"></iframe>', inputObject);
				layout += String.format('</div>');

				layout += String.format('<div id="{0}_layoutUpperDiv" class="qwerty_layoutClass">', inputObject);
				layout += String.format('<iframe id="{0}_block" frameborder="10" style="z-index:-1; position:absolute; visibility: hidden; left: 0px; top: 0px; width: 100%; height: 100%;"></iframe>', inputObject);
				layout += String.format('</div>');

				if (typeof(this.mCommonImage.p_key) != "undefined") {
					layout += String.format('<div id="{0}_press_key" class="press_key">', inputObject);
					layout += String.format('<img src="{0}" alt="" oncontextmenu="return false;" ondragstart="return false;" onselectstart="return false;">', this.mCommonImage.p_key);
					layout += String.format('</div>');
				}

				if (typeof(this.mCommonImage.p_space) != "undefined") {
					layout += String.format('<div id="{0}_press_space" class="press_space">', inputObject);
					layout += String.format('<img src="{0}" alt="" oncontextmenu="return false;" ondragstart="return false;" onselectstart="return false;">', this.mCommonImage.p_space);
					layout += String.format('</div>');
				}

				if (typeof(this.mCommonImage.multi_n) != "undefined") {
					layout += String.format('<div id="{0}_multiMouseTypeDiv" class="qwerty_multiMouseType" onmousedown="ML4WebVKey[\'{1}\'].setMultiCursor(true);">', inputObject, inputObject);
					layout += String.format('<img src="{0}" alt="" id="multiMouseTypeImg" oncontextmenu="return false;" ondragstart="return false;" onselectstart="return false;">', this.mCommonImage.multi_n);
					layout += String.format('</div>');
				}

				if (typeof(this.mCommonImage.multi_p) != "undefined") {
					layout += String.format('<div id="{0}_singleMouseTypeDiv" class="qwerty_multiMouseType" onmousedown="ML4WebVKey[\'{1}\'].setMultiCursor(false);">', inputObject, inputObject);
					layout += String.format('<img src="{0}" alt="" id="slngleMouseTypeImg" oncontextmenu="return false;" ondragstart="return false;" onselectstart="return false;">', this.mCommonImage.multi_p);
					layout += String.format('</div>');
				}

				if (typeof(this.mCommonImage.close) != "undefined") {
					layout += String.format('<div id="{0}_closeLayout" class="closeLayout" onmousedown="ML4WebVKey[\'{1}\'].closeButton();">', inputObject, inputObject);
					layout += String.format('<img src="{0}" alt="" id="closeLayoutImg" oncontextmenu="return false;" ondragstart="return false;" onselectstart="return false;">', this.mCommonImage.close);
					layout += String.format('</div>');
				}
			} else {
				var mobileRow    = 4;
				var mobileCol    = 11;
				var mobileIndex  = 1;
				var mobileWidth  = 9;
				var mobileHeight = 43;
				var mobileClose  = 30;
				var styleHeight  = (mobileHeight*5+mobileClose);

				if (MLVKeyUtils.isMobileDevice() == false)
					element.style.setProperty("width", "550px");
				else
					element.style.setProperty("width", "100%");
				element.style.setProperty("height", styleHeight + "px");

				divMainEvent = String.format('oncontextmenu="return false;" ondragstart="return false;" onselectstart="return false;"');
				divMain = String.format('<div id="{0}_mainDiv" class="mobile_mainDiv" style="height:{1}px;" {2}></div>', inputObject, styleHeight, divMainEvent);

				layout += String.format('<div id="{0}_layoutLowerDiv" class="mobile_qwerty_layoutClass" style="height:{1}px;">', inputObject, styleHeight);

				for (var rindex=mobileRow; rindex>=1; rindex--) {
					for (var index=0; index<mobileCol; index++) {
						var nOffsetX = index * mobileWidth;
						var nOffsetY = mobileHeight * rindex;

						layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_qwerty_layoutClassDiv" style="left:{2}%; bottom:{3}px; width:{4}%; height:{5}px;"></div>', inputObject, mobileIndex, nOffsetX, nOffsetY, mobileWidth, mobileHeight);
						++mobileIndex;
					}
				}

				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_qwerty_layoutClassDiv" style="left: 0%; bottom:   0%; width: 9%; height:{2}px;"></div>', inputObject, mobileIndex++, mobileHeight);
				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_qwerty_layoutClassDiv" style="left: 9%; bottom:   0%; width:18%; height:{2}px;"></div>', inputObject, mobileIndex++, mobileHeight);
				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_qwerty_layoutClassDiv" style="left:27%; bottom:   0%; width:18%; height:{2}px;"></div>', inputObject, mobileIndex++, mobileHeight);
				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_qwerty_layoutClassDiv" style="left:45%; bottom:   0%; width:27%; height:{2}px;"></div>', inputObject, mobileIndex++, mobileHeight);
				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_qwerty_layoutClassDiv" style="left:72%; bottom:   0%; width:27%; height:{2}px;"></div>', inputObject, mobileIndex++, mobileHeight);
				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_qwerty_layoutClassDiv" style="left:81%; bottom:{2}px; width:18%; height:{3}px;"></div>', inputObject, mobileIndex++, mobileHeight*(mobileRow+1), mobileClose);
				layout += String.format('</div>');

				mobileIndex = 1;
				layout += String.format('<div id="{0}_layoutUpperDiv" class="mobile_qwerty_layoutClass" style="height:{1}px;">', inputObject, styleHeight);

				for (var rindex=mobileRow; rindex>=1; rindex--) {
					for (var index=0; index<mobileCol; index++) {
						var nOffsetX = index * mobileWidth;
						var nOffsetY = mobileHeight * rindex;

						layout += String.format('<div id="{0}_layoutUpperDiv{1}" class="mobile_qwerty_layoutClassDiv" style="left:{2}%;  bottom:{3}px; width:{4}%; height:{5}px;"></div>', inputObject, mobileIndex, nOffsetX, nOffsetY, mobileWidth, mobileHeight);
						++mobileIndex;
					}
				}

				layout += String.format('<div id="{0}_layoutUpperDiv{1}" class="mobile_qwerty_layoutClassDiv" style="left: 0%; bottom:   0%; width: 9%; height:{2}px;"></div>', inputObject, mobileIndex++, mobileHeight);
				layout += String.format('<div id="{0}_layoutUpperDiv{1}" class="mobile_qwerty_layoutClassDiv" style="left: 9%; bottom:   0%; width:18%; height:{2}px;"></div>', inputObject, mobileIndex++, mobileHeight);
				layout += String.format('<div id="{0}_layoutUpperDiv{1}" class="mobile_qwerty_layoutClassDiv" style="left:27%; bottom:   0%; width:18%; height:{2}px;"></div>', inputObject, mobileIndex++, mobileHeight);
				layout += String.format('<div id="{0}_layoutUpperDiv{1}" class="mobile_qwerty_layoutClassDiv" style="left:45%; bottom:   0%; width:27%; height:{2}px;"></div>', inputObject, mobileIndex++, mobileHeight);
				layout += String.format('<div id="{0}_layoutUpperDiv{1}" class="mobile_qwerty_layoutClassDiv" style="left:72%; bottom:   0%; width:27%; height:{2}px;"></div>', inputObject, mobileIndex++, mobileHeight);
				layout += String.format('<div id="{0}_layoutUpperDiv{1}" class="mobile_qwerty_layoutClassDiv" style="left:81%; bottom:{2}px; width:18%; height:{3}px;"></div>', inputObject, mobileIndex++, mobileHeight*(mobileRow+1), mobileClose);
				layout += String.format('</div>');

				mobileIndex = 1;
				layout += String.format('<div id="{0}_layoutOtherDiv" class="mobile_qwerty_layoutClass" style="height:{1}px;">', inputObject, styleHeight);

				for (var rindex=mobileRow; rindex>=1; rindex--) {
					for (var index=0; index<mobileCol; index++) {
						var sIndex   = MLVKeyUtils.getPadDigits(mobileIndex, 2);
						var nOffsetX = index * mobileWidth;
						var nOffsetY = mobileHeight * rindex;

						layout += String.format('<div id="{0}_layoutOtherDiv{1}" class="mobile_qwerty_layoutClassDiv"; style="left:{2}%;  bottom:{3}px; width:{4}%; height:{5}px;"></div>', inputObject, mobileIndex, nOffsetX, nOffsetY, mobileWidth, mobileHeight);
						++mobileIndex;
					}
				}

				layout += String.format('<div id="{0}_layoutOtherDiv{1}" class="mobile_qwerty_layoutClassDiv" style="left: 0%; bottom:   0%; width: 9%; height:{2}px;"></div>', inputObject, mobileIndex++, mobileHeight);
				layout += String.format('<div id="{0}_layoutOtherDiv{1}" class="mobile_qwerty_layoutClassDiv" style="left: 9%; bottom:   0%; width:18%; height:{2}px;"></div>', inputObject, mobileIndex++, mobileHeight);
				layout += String.format('<div id="{0}_layoutOtherDiv{1}" class="mobile_qwerty_layoutClassDiv" style="left:27%; bottom:   0%; width:18%; height:{2}px;"></div>', inputObject, mobileIndex++, mobileHeight);
				layout += String.format('<div id="{0}_layoutOtherDiv{1}" class="mobile_qwerty_layoutClassDiv" style="left:45%; bottom:   0%; width:27%; height:{2}px;"></div>', inputObject, mobileIndex++, mobileHeight);
				layout += String.format('<div id="{0}_layoutOtherDiv{1}" class="mobile_qwerty_layoutClassDiv" style="left:72%; bottom:   0%; width:27%; height:{2}px;"></div>', inputObject, mobileIndex++, mobileHeight);
				layout += String.format('<div id="{0}_layoutOtherDiv{1}" class="mobile_qwerty_layoutClassDiv" style="left:81%; bottom:{2}px; width:18%; height:{3}px;"></div>', inputObject, mobileIndex++, mobileHeight*(mobileRow+1), mobileClose);
				layout += String.format('</div>');
			}
			element.innerHTML = divMain + layout;
		}
		this.setNumberLayout = function(inputObject, element) {
			var divMainEvent = '';
			var divMain  = '';
			var layout   = ''

			if (MLVKeyUtils.isAccessiblity() == false && MLVKeyUtils.isMobileDevice() == false) {
				divMainEvent = String.format('onmousedown="ML4WebVKey[\'{0}\'].start(event);" onmousemove="ML4WebVKey[\'{1}\'].showCursor(event,false);" onmouseout="ML4WebVKey[\'{2}\'].hideCursor(event);" onmouseover="ML4WebVKey[\'{3}\'].visibleCursor();" oncontextmenu="return false;" ondragstart="return false;" onselectstart="return false;"', inputObject, inputObject, inputObject, inputObject);

				divMain = String.format('<div class="number_mainDiv" id="{0}_mainDiv" {1}></div>', inputObject, divMainEvent);

				layout += String.format('<div id="{0}_layoutLowerDiv" class="number_layoutClass">', inputObject);
				layout += String.format('<iframe id="{0}_block" frameborder="10" style="z-index:-1; position:absolute; visibility: hidden; left: 0px; top: 0px; width: 100%; height: 100%;"></iframe>', inputObject);
				layout += String.format('</div>');

				layout += String.format('<div id="{0}_layoutUpperDiv" class="number_layoutClass">', inputObject);
				layout += String.format('<iframe id="{0}_block" frameborder="10" style="z-index:-1; position:absolute; visibility: hidden; left: 0px; top: 0px; width: 100%; height: 100%;"></iframe>', inputObject);
				layout += String.format('</div>');

				if (typeof(this.mCommonImage.p_key) != "undefined") {
					layout += String.format('<div id="{0}_press_key" class="press_key">', inputObject);
					layout += String.format('<img src="{0}" alt="" oncontextmenu="return false;" ondragstart="return false;" onselectstart="return false;">', this.mCommonImage.p_key);
					layout += String.format('</div>');
				}

				if (typeof(this.mCommonImage.close) != "undefined") {
					layout += String.format('<div id="{0}_closeLayout" class="number_closeLayout" onmousedown="ML4WebVKey[\'{1}\'].closeButton();">', inputObject, inputObject);
					layout += String.format('<img src="{0}" alt="" id="closeLayoutImg" oncontextmenu="return false;" ondragstart="return false;" onselectstart="return false;">', this.mCommonImage.close);
					layout += String.format('</div>');
				}
			} else {
				var mobileIndex  = 1;
				var mobileWidth  = 25;
				var mobileHeight = 50;
				var mobileClose  = 8;
				var mobileMargin = (100-mobileWidth*4)/2 <= 0 ? 0.5 : (100-mobileWidth*4)/2;

				if (MLVKeyUtils.isMobileDevice() == false){
					element.style.setProperty("width", "190px");
					mobileHeight = 30;
				}else
					element.style.setProperty("width", "100%");
				element.style.setProperty("height", mobileHeight*5 + "px");

				divMainEvent = String.format('oncontextmenu="return false;" ondragstart="return false;" onselectstart="return false;"');

				divMain = String.format('<div id="{0}_mainDiv" class="mobile_mainDiv" style="height:{1}px"; {2}></div>', inputObject, mobileHeight*5, divMainEvent);

				layout += String.format('<div id="{0}_layoutLowerDiv" class="mobile_number_layoutClass" style="margin-left:{1}%; height:{2}px;">', inputObject, mobileMargin, mobileHeight*5);

				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_number_layoutClassDiv" style="left:{2}%; bottom:{3}px; width:{4}%; height:{5}px;"></div>', inputObject, mobileIndex++, mobileWidth*0, mobileHeight*3, mobileWidth, mobileHeight);
				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_number_layoutClassDiv" style="left:{2}%; bottom:{3}px; width:{4}%; height:{5}px;"></div>', inputObject, mobileIndex++, mobileWidth*1, mobileHeight*3, mobileWidth, mobileHeight);
				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_number_layoutClassDiv" style="left:{2}%; bottom:{3}px; width:{4}%; height:{5}px;"></div>', inputObject, mobileIndex++, mobileWidth*2, mobileHeight*3, mobileWidth, mobileHeight);
				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_number_layoutClassDiv" style="left:{2}%; bottom:{3}px; width:{4}%; height:{5}px;"></div>', inputObject, mobileIndex++, mobileWidth*3, mobileHeight*3, mobileWidth, mobileHeight);

				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_number_layoutClassDiv" style="left:{2}%; bottom:{3}px; width:{4}%; height:{5}px;"></div>', inputObject, mobileIndex++, mobileWidth*0, mobileHeight*2, mobileWidth, mobileHeight);
				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_number_layoutClassDiv" style="left:{2}%; bottom:{3}px; width:{4}%; height:{5}px;"></div>', inputObject, mobileIndex++, mobileWidth*1, mobileHeight*2, mobileWidth, mobileHeight);
				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_number_layoutClassDiv" style="left:{2}%; bottom:{3}px; width:{4}%; height:{5}px;"></div>', inputObject, mobileIndex++, mobileWidth*2, mobileHeight*2, mobileWidth, mobileHeight);
				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_number_layoutClassDiv" style="left:{2}%; bottom:{3}px; width:{4}%; height:{5}px;"></div>', inputObject, mobileIndex++, mobileWidth*3, mobileHeight*2, mobileWidth, mobileHeight);

				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_number_layoutClassDiv" style="left:{2}%; bottom:{3}px; width:{4}%; height:{5}px;"></div>', inputObject, mobileIndex++, mobileWidth*0, mobileHeight*1, mobileWidth, mobileHeight);
				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_number_layoutClassDiv" style="left:{2}%; bottom:{3}px; width:{4}%; height:{5}px;"></div>', inputObject, mobileIndex++, mobileWidth*1, mobileHeight*1, mobileWidth, mobileHeight);
				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_number_layoutClassDiv" style="left:{2}%; bottom:{3}px; width:{4}%; height:{5}px;"></div>', inputObject, mobileIndex++, mobileWidth*2, mobileHeight*1, mobileWidth, mobileHeight);
				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_number_layoutClassDiv" style="left:{2}%; bottom:{3}px; width:{4}%; height:{5}px;"></div>', inputObject, mobileIndex++, mobileWidth*3, mobileHeight*1, mobileWidth, mobileHeight);

				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_number_layoutClassDiv" style="left:{2}%; bottom:{3}px; width:{4}%; height:{5}px;"></div>', inputObject, mobileIndex++, mobileWidth*0, mobileHeight*0, mobileWidth, mobileHeight);
				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_number_layoutClassDiv" style="left:{2}%; bottom:{3}px; width:{4}%; height:{5}px;"></div>', inputObject, mobileIndex++, mobileWidth*1, mobileHeight*0, mobileWidth, mobileHeight);
				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_number_layoutClassDiv" style="left:{2}%; bottom:{3}px; width:{4}%; height:{5}px;"></div>', inputObject, mobileIndex++, mobileWidth*2, mobileHeight*0, mobileWidth*2, mobileHeight);
				layout += String.format('<div id="{0}_layoutLowerDiv{1}" class="mobile_number_layoutClassDiv" style="left:{2}%; bottom:{3}px; width:{4}%; height:{5}px;"></div>', inputObject, mobileIndex++, mobileWidth*3, mobileHeight*4, mobileWidth, mobileHeight);

				layout += String.format('</div>');
			}

			element.innerHTML = divMain + layout;
		}
		this.setHiddenField = function(inputObject) {
			var obj = inputObject.form;

			if (obj == null) {
				obj = inputObject.parentNode;
			}
			if (obj == null) {
				obj = document.body;
			}
			try {
				var hidden = document.createElement("input");

				hidden.setAttribute("type",  "hidden");
				hidden.setAttribute("id",    inputObject.id + "_hiddenField");
				hidden.setAttribute("name",  inputObject.id + "_hiddenField");
				hidden.setAttribute("value", "");

				obj.appendChild(hidden);
			} catch(e) {
				throw {code: MLVKeyErrCode.AXERR_API_SCRIPT.code, message: MLVKeyErrCode.AXERR_API_SCRIPT.message + "(setHiddenField)"};
			}

			return hidden;
		}
	}

	return {
		setServlet : function(servletUrl){
			MLVKeyConfig.servlet = servletUrl;
		},
		getServlet : function() {
			return MLVKeyConfig.servlet;
		},
		secureAjax : function(url, data, callback, custom) {
			return MLServlet.secureAjax(url,data,callback,custom);
		},
		secureAjaxMessage : function(data, custom) {
			return MLServlet.secureAjaxMessage(data,custom);
		},
		getMLStatuCode : function(){
			return MLStatusCode;
		},
		init : function(overwrite,callback) {
			try {
				magicjs.init(MLVKeyConfig.magicjsLicense);

				if(typeof(overwrite) != "undefined" && overwrite == true){
					ML4WebVKeyPad = null;
				}

				if (ML4WebVKeyPad == null) {
					ML4WebVKey.now  = null;
					ML4WebVKey.objs = new Array();
					ML4WebVKeyPad   = new magicVKeyPad();

					ML4WebVKeyPad.createSession(function(resultCallback) {
						if (resultCallback.code != 0) {
							alert(resultCallback.message);
							console.log(resultCallback.message);
							MLStatusCode = -1;
							return;
						}

						var inputs = MLVKeyUtils.getAttributeByElementTag("input", "ds-kb-type");

						for (var index=0; index<inputs.length; index++){
							var input = inputs[index];

							if( ML4WebVKey[input.id] != null){
								delete ML4WebVKey[input.id];
							}

							if (input.getAttribute("ds-kb-type") != null && ML4WebVKey[input.id] == null) {
								ML4WebVKeyPad.setVirtualKeyboard(input);
							}
							MLStatusCode = 1;
						}

						if(callback!=null) callback();
					});

					if (document.addEventListener) {
						document.addEventListener("mousedown", ML4WebVKey.onmousedown, false);
					} else if (document.attachEvent) {
						document.attachEvent("onmousedown", ML4WebVKey.onmousedown);
					}

					if (document.addEventListener) {
						window.addEventListener("orientationchange", ML4WebVKey.orientation, false);
					} else if (document.attachEvent) {
						window.attachEvent("onorientationchange​", ML4WebVKey.orientation);
					}

					if (MLVKeyUtils.isAccessiblity() == false && MLVKeyUtils.isMobileDevice() == true) {
						if (document.addEventListener) {
							document.addEventListener("scroll", ML4WebVKey.scroll, false);
						} else if (document.attachEvent) {
							document.attachEvent("onscroll", ML4WebVKey.scroll);
						}
					}

				}
			} catch(ex) {
				console.log(ex);
				MLStatusCode = -1;
			}
		},
		showKeyboard : function(elementId,callback, tobefocusedId) {
			try {
				var trigger = false;

				if (typeof(elementId) != "undefined" && typeof(ML4WebVKey[elementId]) != "undefined") {
					if (ML4WebVKey[elementId].inputField.getAttribute("ds-kb-focus") == "check") {
						var option1 = ML4WebVKey[elementId].layoutLowerDiv.style.display;
						var option2 = ML4WebVKey[elementId].layoutUpperDiv.style.display;

						if  (option1 == "none" && option2 == "none") {
							ML4WebVKey[elementId].showKeyboard(callback, tobefocusedId);
							trigger = true;
						} else {
							ML4WebVKey[elementId].hideKeyboardLayout();
							trigger = false;
						}
					} else {
						ML4WebVKey[elementId].showKeyboard(callback, tobefocusedId);
						trigger = true;
					}
				}
				/**
				 * v1.2.3.0b
				 * 장애인 접근성, mobile 일때만 해당 - 첫번째 Element Focus
				 if ( trigger && (MLVKeyUtils.isMobileDevice() == true || MLVKeyUtils.isAccessiblity() == true)) {
				 var targetAccessiblity = document.getElementById(elementId+"_layoutLowerDiv1");
				 targetAccessiblity.style.setProperty("z-index","2147483647");
				 targetAccessiblity.style.setProperty("border","2px solid black");
				 targetAccessiblity.style.setProperty("border-radius","4px");
				 targetAccessiblity.addEventListener('focusout', (event)=>{
				 event.target.style.setProperty("border","0px");
				 event.target.style.setProperty("z-index","");
				 });
				 let count = 0;
				 function focusTimer(count) {
				 let timerId = setInterval(() => {targetAccessiblity.focus();}, 300);
				 setTimeout(() => {
				 clearInterval(timerId);
				 if (document.activeElement.id.indexOf("_layoutLowerDiv1") < 0 && ++count < 4) {
				 focusTimer(count);
				 }
				 }, 1000);
				 };
				 focusTimer(count);
				 }
				 */

			} catch (ex) {
				console.log(ex);
				MLStatusCode = -2;
			}
		},
		hideKeyboard : function(elementId) {
			try {
				if (typeof(elementId) != "undefined" && typeof(ML4WebVKey[elementId]) != "undefined") {
					return ML4WebVKey[elementId].hideKeyboardLayout();
				}
			} catch (ex) {
				console.log(ex);
			}
		},
		getEncryptedPassword : function(elementId) {
			var result = "";

			try {
				if (typeof(elementId) == "undefined") {
					for (var i=0; i<ML4WebVKey.objs.length; i++) {
						result += ML4WebVKey[ML4WebVKey.objs[i]].encryptedPassword();
						result += "$";
					}
				} else if (typeof(elementId) != "undefined") {
					for (var i=0; i<arguments.length; i++) {
						if (typeof(ML4WebVKey[arguments[i]]) != "undefined") {
							result += ML4WebVKey[arguments[i]].encryptedPassword();
						} else {
							result += "'" + arguments[i] + "' undefined";
						}
						result += "$";
					}

				} else {
				}
			} catch (ex) {
				console.log(ex);
			}

			result = result.slice(0,-1);
			result += "&decryptedType=server";

			return result;
		},
		getDecryptedPassword : function(elementId, callback) {
			try {
				if (typeof(elementId) != "undefined" && typeof(ML4WebVKey[elementId]) != "undefined") {
					return ML4WebVKey[elementId].decryptPassword(callback);
				} else {
					return "";
				}
			} catch (ex) {
				console.log(ex);
				return "";
			}
		},
		scroll : function(jsEvent) {
			if (!ticking) {
				window.requestAnimationFrame(function() {
					setTimeout(function(){
						var scrollLocation = document.documentElement.scrollTop;// 현재 스크롤바 위치
						var windowHeight   = window.innerHeight;				// 스크린 창
						var fullHeight     = document.body.scrollHeight;		// margin 값은 포함 x

						var targetElement = ML4WebVKey.now.mainDiv;
						if(targetElement == null) return;

						var startPositionY = scrollLocation + (windowHeight-parseInt(targetElement.style.height));

						ML4WebVKey.now.layoutDiv.style.setProperty("top",  startPositionY-10 + "px");
					},100);
					ticking = false;
				});

				ticking = true;
			}
		},
		orientation : function(jsEvent) {
			if (MLVKeyUtils.isAccessiblity() == false && MLVKeyUtils.isMobileDevice() == true) {
				setTimeout(function(){
					var scrollLocation = document.documentElement.scrollTop;// 현재 스크롤바 위치
					var windowHeight   = window.innerHeight;				// 스크린 창
					var fullHeight     = document.body.scrollHeight;		// margin 값은 포함 x
					var startPositionY = scrollLocation + (windowHeight-parseInt(ML4WebVKey.now.mainDiv.style.height));

					ML4WebVKey.now.layoutDiv.style.setProperty("top",  startPositionY-10 + "px");
				},100);
			}
		},
		onmousedown : function(jsEvent) {
			var selectObject = null;
			console.log(`jsEvent... `, jsEvent);

			const distinguishKey = () => {
				const targetId = jsEvent.target.id;
				const elemId = targetId.substring(0, targetId.indexOf("_layout"));
				const keypadType = ML4WebVKey[elemId]?.mKeyboardType;
				if (!keypadType) return false;

				if (keypadType === "qwerty"
						&& (targetId.indexOf("Div50") > 0 || targetId.indexOf("Div49") > 0)) {
					return true;
				} else if (keypadType === "number"
						&& (targetId.indexOf("Div16") > 0 || targetId.indexOf("Div15") > 0)) {
					return true;
				} else {
					return false;
				}
			}

			// 마우스 클릭시 && 엔터,닫기 제외
			function hideKeyboardLayout() {
				if (ML4WebVKey.now != null
						&& typeof(ML4WebVKey.now.layoutDiv.style.display) != "undefined"
						&& ML4WebVKey.now.layoutDiv.style.display === "block")
				{
					const args = {
						"onmousedown": true
						, "useFocusTag": distinguishKey()
					};
					ML4WebVKey.now.closeButton(args);
				}
				MLStatusCode = 1;
			}

			function isEditableElement(id) {
				var el = document.getElementById(id);
				if( el==null ){ return false;
				} else{
					if (el instanceof HTMLElement && el.isContentEditable) return true;
					if (el instanceof HTMLInputElement) {
						let pattern = /text|email|number|password|search|tel|url/;
						if (pattern.test(el.type || '')) {
							return !(el.disabled || el.readOnly);
						}
					}
					if (el instanceof HTMLTextAreaElement) return !(el.disabled || el.readOnly);
					return false;
				}
			}

			// 1. when click key, and go to first key
			// 2. jump to a key set by user, when key clicked
			// focus by 1/10 sec interval, after 1/2sec stop
			const keyname = jsEvent.target.getAttribute("keyname");
			if (keyname === "refresh") {
				// change id
				var tid = jsEvent.target.id;
				var target = document.getElementById(tid.substr(0, tid.indexOf("layout") + 6)+"LowerDiv1");
				let timerId = setInterval(() => target.focus(), 100);
				setTimeout(() => { clearInterval(timerId); }, 700);
				return true;
			} else if (keyname === "shift"
					|| keyname === "special"
					|| keyname === "enter"
					|| jsEvent.target.id.indexOf("Div50") > 0)
			{
				let target = document.activeElement;
				let timerId = setInterval(() => target.focus(), 100);
				setTimeout(() => { clearInterval(timerId);}, 700);
				return true;
			}

			/** 250423 "키보드 닫히고서 포커스가 키보드로 이동하지 않도록 수정" 건의 예외사항 */
			// ds-kb-focustag id 값으로 focus 이동
			// 숫자 키패드, 닫기버튼만 해당 (그 외는 this.hideKeyboardLayout() 에서 확인가능)
			if( distinguishKey() ){

				const focusTagId = ML4WebVKey.now.inputField.getAttribute("ds-kb-focustag");
				if ( !(focusTagId && typeof focusTagId === "string") ) return;

				const focusElem = document.getElementById(focusTagId);
				let timerId = setInterval(() => focusElem.focus(), 100);
				setTimeout(() => { clearInterval(timerId);}, 500);
				return true;
			}


			if (jsEvent.type == "text" || jsEvent.type == "password") {
				selectObject = jsEvent;
			} else {
				jsEvent = jsEvent ? jsEvent : window.event;
				selectObject = jsEvent.target ? jsEvent.target : jsEvent.srcElement;
			}

			if (selectObject.type === "text" || selectObject.type === "password") {
				if (ML4WebVKey.now != null
						&& ML4WebVKey.now.inputField.id !== selectObject.id
						&& ML4WebVKey.now.inputField.getAttribute("ds-kb-focus") !== "check") {
					return hideKeyboardLayout();
				}

				if (selectObject.getAttribute("ds-kb-type") != null) {

					if (selectObject.getAttribute("ds-kb-focus") == "true") {
						selectObject.readOnly = true;
						var checkObject = setInterval(function() {
							if (typeof(ML4WebVKey[selectObject.id]) != "undefined") {
								clearInterval(checkObject);
								ML4WebVKey.showKeyboard(selectObject.id);
							}
						}, 100);
					}
				}
			} else {
				if (typeof(selectObject.id) != "undefined" && selectObject.id === "") {
					if (ML4WebVKey.now != null && ML4WebVKey.now.inputField.getAttribute("ds-kb-focus") != "check") {
						return hideKeyboardLayout();
					}
				} else {
					if (ML4WebVKey.now != null) {
						var items = ML4WebVKey.now.layoutDiv.childNodes;
						var count = ML4WebVKey.now.layoutDiv.childNodes.length;

						for (var i=0; i<count; i++) {
							var elementId = ML4WebVKey.now.layoutDiv.childNodes[i].id;

							if (selectObject.id.indexOf(elementId) >=0) {
								return true;
							}
							// TODO : close 버튼에 포커스 가도록
							// if (selectObject.id.indexOf(elementId) >=0 ){
							//
							// 	const targetId = jsEvent.target.id;
							// 	const elemId = targetId.substring(0, targetId.indexOf("_layout"));
							// 	console.log('ML4WebVKey[elemId]:', ML4WebVKey[elemId]);
							// 	const keypadType = ML4WebVKey[elemId]?.mKeyboardType;
							// 	if (!keypadType) return false;
							//
							// 	if (keypadType === "qwerty"
							// 			&& (targetId.indexOf("Div50")>0
							// 					|| targetId.indexOf("Div49")>0)) {
							// 		// return true;
							// 		console.log('qwert close');
							// 	} else if (keypadType === "number"
							// 			&& (targetId.indexOf("Div16")>0
							// 					|| targetId.indexOf("Div15")>0)) {
							// 		// return true;
							// 		console.log('number close');
							// 	} else {
							// 		return true;
							// 	}
							// }
						}
						if (ML4WebVKey.now.inputField.getAttribute("ds-kb-focus") != "check") {
							return hideKeyboardLayout();
						}
					}
				}
			}
		},
		buttonclick : function(jsEvent) {
			var selectObject = null;

			jsEvent = jsEvent ? jsEvent : window.event;
			selectObject = jsEvent.target ? jsEvent.target : jsEvent.srcElement;

			if (typeof(selectObject.id) != "undefined" && selectObject.id.indexOf("_magicButton")) {
				var selectId = selectObject.id.slice(0, selectObject.id.indexOf("_magicButton"));

				var checkObject = setInterval(function() {
					if (typeof(ML4WebVKey[selectId]) != "undefined") {
						clearInterval(checkObject);
						ML4WebVKey[selectId].showKeyboard();
					}
				}, 100);
			}
		},
		setLimitOverCount : function(mLlimitOverCount){
			limitOverCount = mLlimitOverCount;
		},
		setLimitOver : function(mlimitOver){
			limitOver = mlimitOver;
		},
		getLimitOver : function(){
			return limitOver;
		}
	}

}());










